import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import SlidingPane from "react-sliding-pane";
import ContentLoader from "react-content-loader";
import Form from "react-validation/build/form";
import { set, useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from "react-toastify";
import MaterialTable from "material-table";

import authHeader from "../../../../services/auth-header";
import AssetList from "../../../../components/assetList";
import EditContractLoanService from "../../../../services/contract/editContractLoanService";
import ActivateContractLoanService from "../../../../services/contract/ActiveContractLoanService";
import { API } from "../../../../backend";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
import PaymentScheduleview from "../paymentScheduleview";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import ContractShortview from "../contractshortview";
import AmortizationSchedule from "../AmortSchedulDetail/CalculateAmortSchedule";
import AmortizationScheduleArrears from "../AmortSchedulDetail/ArrearsAmortSchedule";
import AssetView from "../Asset/AssetView";
import Doc from "../../../UploadDocument/doc";
import lineOfBusinessService from "../../../../services/company/lineofbusinessService";
import subcompanyService from "../../../../services/company/subcompanyService";
import PartyRoleList from "../../PartyRole/PartyRoleList";
import TermConditionContractView from "../../TermsCondition/TermConditionContractView";

import { use } from "react";
import { act } from "react";

function EditLoanScreen({ customerPermission, setCustomData }) {
  const { state } = useLocation();

  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [address, setAddress] = useState([]);
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState("");
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [paymentstartdate, setPaymentStartDate] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [iir, setIir] = useState();
  const [interestcalculationmethod, setInterestCalculationMethod] =
    useState("");
  const [repaymentprocedure, setRepaymentProcedure] = useState("");
  const [timecountingmethod, setTimeCountingMethod] = useState("");
  const [interestpostingfrequency, setInterestpostingFrequency] = useState("");
  const [paymentmethod, setPaymentMethod] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [asset_count, setAsset_count] = useState(0);
  const [payment_count, setPayment_count] = useState(0);
  const [paymentrule, setPaymentRule] = useState("Arrears");
  const [paymentfrequency, setPaymentFrequency] = useState("");
  const [showActivate, setShowActivate] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeloading, setActiveLoading] = useState(false);
  const [customer_id, setCustomer_id] = useState("");
  const [contract, setConract] = useState([]);
  const [status, setStatus] = useState("");
  // const [calu, setCalu] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  // const [isLoadingVal, setIsLoadingVal] = useState(false)
  const [key, setKey] = useState("");
  const [object_name, setObject_name] = useState("Contract");
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const form = useRef();
  const isFirstRender = useRef(true);
  const [item, setItems] = useState([]);
  const [amortcalcu, SetAmortCalculation] = useState([]);
  const [rentamount, setRentAmount] = useState(0);
  const [numberofpayment, setNumberofpayment] = useState(0);
  const [paymentdetail, setPaymentDeatil] = useState([]);
  const [feedefination, setFeeDefination] = useState([]);
  const [refreshdetail, setRefreshPaymentDetails] = useState(false);
  const residual = 0;
  const [totalRent, setTotalRent] = useState(0);
  const [totalonetimefee, setTotalOneTimeFee] = useState(0);
  const [disableparty, setDisableparty] = useState(false);

  const [achPayments, setAchPayments] = useState(false); // New state for ACH Payments checkbox
  const [achAccounts, setAchAccounts] = useState([]); // New state for ACH Accounts list
  const [achAccount, setAchAccount] = useState("");

  const [appOriginator, setAppOriginator] = useState("");
  const [source, setSource] = useState("");
  const [salesRep, setSalesRep] = useState("");
  const [subcompany, setSubcompany] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);
  const [interest_only_payments, setInterestOnlyPayments] = useState(0);

  const [isApiUpdating, setIsApiUpdating] = useState(false);

  const [interestRateType, setInterestRateType] = useState("Fixed");
  const [baseRate, setBaseRate] = useState(0);
  const [margin, setMargin] = useState(0);

  const fetchSubcompanies = () => {
    try {
      subcompanyService.getSubcompany().then((response) => {
        setSubcompanyOptions(response.data || []);
        // if (response.data.length > 0) {
        //   setSubcompany(response.data[0].id); // Set default to first option
        //   reset({ subcompany: response.data[0].id });
        // }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch Lines of Business
  const fetchLinesOfBusiness = () => {
    try {
      lineOfBusinessService.getLineOfBusiness().then((response) => {
        setLineOfBusinessOptions(response.data || []);
        // if (response.data.length > 0) {
        //   setLineOfBusiness(response.data[0].id); // Set default to first option
        //   reset({ lineOfBusiness: response.data[0].id });
        // }
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSubcompanies();
    fetchLinesOfBusiness();
  }, []);

  // add party customer
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();

  //party screen
  const [party_type, setParty_type] = useState("Customer");
  const [customer_type, setCustomer_type] = useState("");
  const [showhide, setShowHide] = useState("");
  const [customer_nameparty, setCustomer_nameParty] = useState("");
  const [establishment_date, setEstablishment] = useState(null);
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);

  // Address Screen
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("No");
  const [install_to, setInstall_to] = useState("Yes");

  const [selectedBill, setSelectedBill] = useState(null);
  const [filterBill, setFilterBill] = useState([]);

  const [state1, setState1] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [rowsData, setRowsData] = useState([]);
  const [termError, setTermError] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [paymentType, setPaymentType] = useState([]);
  const [amount, setAmount] = useState(null);

  const form6 = useRef();
  const checkBtn6 = useRef();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    reset: reset6,
    // formState: { errors: errors5 },
  } = useForm();

  const [frequencyMapped, setFrequencyMapped] = useState({
    Monthly: 1,
    Quarterly: 3,
    SemiAnnual: 6,
    Annual: 12,
  });
  const [state5, setState5] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [paymentFrequencystep, setPaymentFrequencystep] = useState([
    { value: 1, label: "Monthly" },
    { value: 3, label: "Quarterly" },
    { value: 6, label: "Semi-annual" },
    { value: 12, label: "Annual" },
  ]);

  const [pacakge, setPackage] = useState([]);
  const [companydata, setCompany] = useState([]);
  const [addTable, setAddTable] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const assetId = searchParams.get("Asset");
  const [assetTabActivated, setAssetTabActivated] = useState(false);
  const [assetid, setassetID] = useState("");
  const [tabcontractIndex, setTabContractIndex] = useState(assetId ? 1 : 0);

  useEffect(() => {
    setassetID(assetId);
  }, [assetId]);

  useEffect(() => {
    if (assetId && !assetTabActivated) {
      setTabContractIndex(1);
      setAssetTabActivated(true);
    }
  }, [assetId, assetTabActivated]);

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };

  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", {
      headers: authHeader(),
    });
    const getcon = await res.json();
    setPackage(getcon);
  };

  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setCompany(response.data);
    });
  };
  useEffect(() => {
    packagedata();
    company();
  }, []);
  const free = pacakge.filter((value) => value.name === companydata.plan);

  const handleAddress = (id) => {
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
        // extrafiledpartyyaddress
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddress_line_1("");
          setAddress_line_2("");
          setCity("");
          setStateAddress("");
          setZip_code("");
          setAdddressId(response.data.addressId);
        }
      });
    }
  };

  const handleparty = () => {
    setDisableparty(true);
    form2.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn2.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(
        customer_type,
        party_type,
        customer_nameparty
        //   establishmentDate,
        //   sales_tax_code,
        //   TIN_number,
        //   website,
        //   prefix,
        //   first_name,
        //   middle_name,
        //   last_name,
        //   ssn_tin_number,
        //   id_number,
        //   id_issue_state,
        //   dateofbirth,
        //   filedparty,
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setDisable(true);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            // closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          // reset({
          //     vendorname1:response.data.partyId
          // })
          // setVendor_name(response.data.partyId)
          handleAddress(response.data.partyId);
          loadInitialOptions(customer_nameparty);
          reset({
            selectedValue: response.data.partyId,
          });
          setTimeout(() => {
            // handelDefault()
            setDisableparty(false);
            setSelectedValue(response.data.partyId);
            setState1({ isPaneOpen: false });
          }, 1000);
          setCustomer_nameParty("");
          setCustomer_type("");
        } else {
          setLoading(false);
          setDisableparty(false);
          setSuccessful(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            // closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handlepartydefault = () => {
    AddPartyService.partyvalidate(customer_nameparty).then((response) => {
      if (response.data.success) {
        handleparty();
      } else {
        confirmAlert({
          title: "",
          message: `Party ${customer_nameparty} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    });
  };

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name,
    });
  }, [object_name, setCustomData, state]);

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    if (value === null) {
      setSelectedValue(value);
      reset({
        selectedValue: value,
      });
      setAddress([]);
      setAdddressId("");
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
    } else {
      setSelectedValue(value.id);
      reset({
        selectedValue: value.id,
        achPayments: false,
        achAccount: "",
      });
      const customerId = value.id;
      const customerName =
        value.name || value.label || value.customer_name || ""; // depends on your object shape

      fetchAchAccounts(customerId, "", false, false, customerName);
    }
  };

  const fetchAchAccounts = async (
    customerId,
    contractAchId = "",
    useContractAchEnabled = false,
    contractAchEnabled = "N"
  ) => {
    if (!customerId) {
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      reset({ achPayments: false, achAccount: "" });
      return;
    }
    try {
      // Fetch ACH accounts for the customer
      const response = await axios.get(
        `${API}parties/api/ach-accounts/?party_id=${customerId}`,
        { headers: authHeader() }
      );
      const accounts = response.data.details || [];
      setAchAccounts(accounts);

      // Fetch customer data to get ACHPayments status
      let achEnabled = false;
      console.log("useContractAchEnabled:", useContractAchEnabled);

      if (useContractAchEnabled) {
        achEnabled = useContractAchEnabled;
      } else if (useContractAchEnabled === false) {
        achEnabled = useContractAchEnabled;
      } else {
        const customerResponse = await axios.get(
          `${API}parties/vendor/?party_type=Customer&customer_name=${customer_name}`,
          { headers: authHeader() }
        );
        const customer = customerResponse.data.data.find(
          (c) => c.id === customerId
        );
        achEnabled = customer?.ACHPayments || false;
      }
      // const customerResponse = await axios.get(
      //   `${API}parties/vendor/?party_type=Customer&customer_name=${customer_name}`,
      //   { headers: authHeader() }
      // );
      // const customer = customerResponse.data.data.find(
      //   (c) => c.id === customerId
      // );
      // // const achEnabled = customer?.ACHPayments || false;
      // const achEnabled = contract?.enable_ach || false;
      setAchPayments(achEnabled);

      // if (accounts.length === 0) {
      //   setAchAccount("");
      //   reset({ achPayments: achEnabled, achAccount: "" });
      // } else {
      //   // If contract has an ach_account_id, try to select it; otherwise, select none
      //   const contractAchAccount = accounts.find(
      //     (account) => account.id === contract.ach_account_id
      //   );
      //   const selectedAccountId = contractAchAccount ? contractAchAccount.id : "";
      //   setAchAccount(selectedAccountId);
      //   reset({ achPayments: achEnabled, achAccount: selectedAccountId });
      // }
      let selectedAccountId = "";

      if (accounts.length > 0) {
        const selectedAccount = accounts.find(
          (account) => account.id === contractAchId
        );
        selectedAccountId = selectedAccount ? selectedAccount.id : "";
      }

      setAchAccount(selectedAccountId);
      reset({ achPayments: achEnabled, achAccount: selectedAccountId });
    } catch (error) {
      console.error("Error fetching ACH accounts:", error);
      toast.error("Failed to load ACH accounts", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      reset({ achPayments: false, achAccount: "" });
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async (value) => {
    if (value !== undefined) {
      const responseJSON = await axios.get(
        API + `parties/vendor/?party_type=Customer&&customer_name=${value}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    } else {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    }
  };
  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const Paymentstartdate = (value) => {
    setPaymentStartDate(value);
    reset({
      paymentstartdate: value,
    });
  };

  const handelStart_Date = (value) => {
    setStart_date(value);
    reset({
      startdate: value,
    });
    // ✅ Only recalc when user changes date
    // setTimeout(() => {
    // setenddate();
    setenddate(value, paymentfrequency, paymentrule);
    // }, 0);
  };

  const handleFrequencyChange = (value) => {
    setPaymentFrequency(value);
    // setTimeout(() => {
    setenddate(start_date, value, paymentrule);
    // }, 0);
  };

  const handlePaymentRuleChange = (value) => {
    setPaymentRule(value);
    setTimeout(() => {
      setenddate();
    }, 0);
  };

  const handlepayment = () => {
    let url = API + "contracts/paymentschedule-view/" + state + "/";
    axios
      .post(url, { payment_schedule: rowsData }, { headers: authHeader() })
      .then((response) => {
        setItems(response.data.data);
        setState5({ isPaneOpen: false });
      });
  };

  useEffect(() => {
    getEndDate();
    loadInitialOptions();
  }, [start_date, contract_term, interest_only_payments]);

  const handelContract_term = (value) => {
    setContract_term(value);
  };

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    });
  };
  const isFirstDayOfMonth = (date) => {
    return date.getDate() === 1;
  };
  const isLastDayOfMonth = (date) => {
    const tempDate = new Date(date);
    tempDate.setDate(tempDate.getDate() + 1);
    return tempDate.getDate() === 1;
  };

  const getLastDayOfMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();
  function isFebruary(date) {
    return date.getMonth() === 1;
  }
  const setenddate = (
    customStartDate = start_date,
    customFrequency = paymentfrequency,
    customRule = paymentrule
  ) => {

    if (!customStartDate) return;

    var contractDateObj = new Date(customStartDate);

    const frequencyMapping = {
      Monthly: { months: 1 },
      Quarterly: { months: 3 },
      "Semi-annual": { months: 6 },
      Annual: { months: 12 },
    };

    const getLastDayOfMonth = (year, month) =>
      new Date(year, month + 1, 0).getDate();

    let paymentStartDate;

    // ---------------------------
    // ADVANCE
    // ---------------------------
    if (customRule === "Advance") {

      paymentStartDate = new Date(contractDateObj);

    }

    // ---------------------------
    // ARREARS
    // ---------------------------
    else if (customRule === "Arrears") {

      const cycleDelta = frequencyMapping[customFrequency];

      if (!cycleDelta) return;

      const originalDay = contractDateObj.getDate();

      let targetYear = contractDateObj.getFullYear();
      let targetMonth = contractDateObj.getMonth() + cycleDelta.months;

      const lastDay = getLastDayOfMonth(targetYear, targetMonth);

      const targetDay = Math.min(originalDay, lastDay);

      paymentStartDate = new Date(targetYear, targetMonth, targetDay);
    }

    // ---------------------------
    // SET STATE
    // ---------------------------
    if (paymentStartDate) {
      setPaymentStartDate(paymentStartDate);

      reset({
        paymentstartdate: paymentStartDate,
      });
    }
  };
  // const setenddate = (no_of_payments) => {
  // const setenddate = (no_of_payments) => {
  //   if (start_date === "") {
  //     return false;
  //   }

  //   var contractDateObj = new Date(start_date);
  //   const frequencyMapping = {
  //     Monthly: { months: 1 },
  //     Quarterly: { months: 3 },
  //     "Semi-annual": { months: 6 },
  //     Annual: { months: 12 },
  //   };
  //   // Calculate the payment start date based on the payment rule
  //   let paymentStartDate, paymentEndDate;
  //   const freqMonths = frequencyMapping[paymentfrequency]?.months || 0;


  //   const isLeapYear = (year) => {
  //     return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  //   };

  //   // const getLastDayOfMonth = (year, month) => {
  //   //   return new Date(year, month + 1, 0).getDate();
  //   // };
  //   if (paymentrule === "Advance") {
  //     paymentStartDate = contractDateObj;
  //   } else if (paymentrule === "Arrears") {
  //     const cycleDelta = frequencyMapping[paymentfrequency];

  //     const originalDay = contractDateObj.getDate();

  //   let targetYear = contractDateObj.getFullYear();
  //   let targetMonth = contractDateObj.getMonth() + cycleDelta.months;

  //   // Get last valid day of target month
  //   const lastDay = getLastDayOfMonth(targetYear, targetMonth);

  //   // If original day > last day, clamp to last day
  //   const targetDay = Math.min(originalDay, lastDay);

  //   paymentStartDate = new Date(targetYear, targetMonth, targetDay);

  //     // const originalDay = contractDateObj.getDate();
  //     // if (isFirstDayOfMonth(contractDateObj)) {
  //     //   paymentStartDate = new Date(contractDateObj);
  //     //   paymentStartDate = new Date(
  //     //     paymentStartDate.getFullYear(),
  //     //     paymentStartDate.getMonth() + cycleDelta.months,
  //     //     1
  //     //   );
  //     //   // paymentStartDate.setDate(paymentStartDate.getDate() - 1)
  //     //   paymentStartDate.setDate(paymentStartDate.getDate());
  //     // } else if (isLastDayOfMonth(contractDateObj)) {
  //     //   // For non-February months, set to last day of target month if original is last day
  //     //   // paymentStartDate.setDate(1); // Move to 1st of next month
  //     //   paymentStartDate = new Date(contractDateObj);
  //     //   paymentStartDate = new Date(
  //     //     paymentStartDate.getFullYear(),
  //     //     paymentStartDate.getMonth() + cycleDelta.months
  //     //   );
  //     //   // console.log("set new month date", paymentd);
  //     //   // paymentStartDate.setMonth(paymentStartDate.getMonth() + cycleDelta.months);
  //     //   if (isFebruary(paymentStartDate)) {
  //     //     // If target month is February, set to 29 (leap year) or 28 (non-leap year)
  //     //     paymentStartDate.setDate(
  //     //       isLeapYear(paymentStartDate.getFullYear()) ? 29 : 28
  //     //     );
  //     //   } // No setDate(0) here; keep the adjusted date (e.g., Jan 31 for Dec 31)
  //     //   else {
  //     //     console.log("set date", paymentStartDate.getDate());
  //     //     paymentStartDate.setMonth(
  //     //       paymentStartDate.getMonth() + cycleDelta.months
  //     //     );
  //     //     paymentStartDate.setDate(0);
  //     //   }
  //     // } else {
  //     //   paymentStartDate = new Date(contractDateObj);
  //     //   paymentStartDate.setMonth(
  //     //     paymentStartDate.getMonth() + cycleDelta.months
  //     //   );
  //     //   if (isFebruary(paymentStartDate) && originalDay >= 30) {
  //     //     // For dates >= 30 in January, set to 29 (leap year) or 28 (non-leap year)
  //     //     paymentStartDate.setDate(
  //     //       isLeapYear(paymentStartDate.getFullYear()) ? 30 : 29
  //     //     );
  //     //   } else {
  //     //     // Otherwise, keep the original day
  //     //     paymentStartDate.setDate(originalDay);
  //     //   }
  //     // }

  //   //   if (isFirstDayOfMonth(contractDateObj)) {
  //   //     paymentStartDate = new Date(contractDateObj);
  //   //     paymentStartDate = new Date(
  //   //       paymentStartDate.getFullYear(),
  //   //       paymentStartDate.getMonth() + cycleDelta.months,
  //   //       1
  //   //     );
  //   //     paymentStartDate.setDate(paymentStartDate.getDate() - 1);
  //   //   } else {
  //   //     // paymentStartDate = new Date(contractDateObj);
  //   //     paymentStartDate = new Date(
  //   //       contractDateObj.getFullYear(),
  //   //       contractDateObj.getMonth() + cycleDelta.months
  //   //     );
  //   //     // paymentStartDate.setMonth(
  //   //     //   paymentStartDate.getMonth() + cycleDelta.months
  //   //     // );
  //   //     if (
  //   //       paymentStartDate.getMonth() === 1 &&
  //   //       contractDateObj.getDate() > 28
  //   //     ) {
  //   //       // If the month is February
  //   //       const year = paymentStartDate.getFullYear();

  //   //       const lastDayOfFeb = isLeapYear(year) ? 30 : 29;
  //   //       paymentStartDate.setDate(lastDayOfFeb - 1);
  //   //     } else {
  //   //       paymentStartDate.setDate(contractDateObj.getDate() - 1);
  //   //     }
  //   //     // paymentStartDate.setDate(paymentStartDate.getDate() - 1)
  //   //   }
  //   // }
  //   }
  //   // const noofpayment = frequencyMapping[paymentfrequency];

  //   paymentEndDate = new Date(contractDateObj);
  //   paymentEndDate.setMonth(paymentEndDate.getMonth() + contract_term);
  //   paymentEndDate.setDate(paymentEndDate.getDate() - 1);

  //    // -----------------------
  // // APPLY INTEREST-ONLY SHIFT
  // // -----------------------
  // // if (interest_only_payments && parseInt(interest_only_payments) > 0) {
  // //   const extraMonths = parseInt(interest_only_payments) * freqMonths;

  // //   let y = paymentStartDate.getFullYear();
  // //   let m = paymentStartDate.getMonth() + extraMonths;
  // //   let d = paymentStartDate.getDate();

  // //   const lastDay = new Date(y, m + 1, 0).getDate();
  // //   paymentStartDate = new Date(y, m, Math.min(d, lastDay));
  // // }

  //   setPaymentStartDate(paymentStartDate);
  //    reset({
  //     paymentstartdate: paymentStartDate,
  //   });
  // };

  // useEffect(() => {
  //   // setenddate();
  //  if (isApiUpdating) return;

  // // ✅ Run only when user changes values
  // setenddate();
  // }, [start_date, paymentfrequency, paymentrule]);

  const getEndDate = () => {
    if (start_date === "") {
      return false;
    }
    // var dt = new Date(start_date);
    var dt = new Date(paymentstartdate);
    var term = parseInt(contract_term);
    const frequencyMapping = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const freqMonths = frequencyMapping[paymentfrequency] || 0;
    if (term !== "" && !isNaN(dt)) {
      const totalMonths = term * freqMonths;

      dt.setMonth(dt.getMonth() + totalMonths);
      dt.setDate(dt.getDate() - 1);
      // 👉 ADD INTEREST ONLY EXTENSION
      // if (interest_only_payments && parseInt(interest_only_payments) > 0) {
      //   const extraMonths = parseInt(interest_only_payments) * freqMonths;

      //   let endYear = dt.getFullYear();
      //   let endMonth = dt.getMonth() + extraMonths;
      //   let endDay = dt.getDate();

      //   const lastDay = new Date(endYear, endMonth + 1, 0).getDate();
      //   dt = new Date(endYear, endMonth, Math.min(endDay, lastDay));
      // }
      setEnd_date(dt);
    }
  };

  //   const getEndDate = () => {
  //     if (!paymentstartdate || !contract_term) return;

  //     const start = new Date(paymentstartdate);
  //     if (isNaN(start)) return;

  //     const term = parseInt(contract_term);
  //     if (isNaN(term) || term <= 0) return;

  //     const frequencyMapping = {
  //         Monthly: 1,
  //         Quarterly: 3,
  //         "Semi-annual": 6,
  //         Annual: 12,
  //     };

  //     const freqMonths = frequencyMapping[paymentfrequency] || 1;

  //     // 👉 total months = term × frequency
  //     const totalMonths = term * freqMonths;

  //     let end = new Date(start);
  //     end.setMonth(end.getMonth() + totalMonths);

  //     // 👉 end date = one day before next cycle
  //     end.setDate(end.getDate() - 1);

  //     setEnd_date(end);
  // };

  const getaddress = async () => {
    // setIsLoading(true)
    // setLoading(true)
    if (selectedValue !== null) {
      const resst = await fetch(
        API +
        "parties/manage-address/" +
        selectedValue +
        "/?address_type=bill_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setAddress(await getst.data);
      setIsLoading(false);

      if (address_id !== "") {
        setAdddressId(address_id);
        // setLoading(false)
        // setIsLoading(false)
      } else {
        setAdddressId(await getst.data[0].id);
        setIsLoading(false);
        reset({
          address: await getst.data[0].id,
        });
        // setLoading(false)
        // setIsLoading(false)
      }
    }
  };

  const data_count = (items) => {
    if (items === "") setShowActivate(0);
    else setShowActivate(1);
  };

  const FeeDefination = () => {
    let url =
      API +
      "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setFeeDefination(response.data);
      setPaymentType(response.data);
    });
  };
  useEffect(() => {
    FeeDefination();
  }, []);

  const handlepaymentdetailview = () => {
    let url = API + "contracts/payment-view/" + state + "/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      if (contract_type === "Loan") {
        try {
          const responsepay = axios.get(
            `${API}contracts/paymentScheduleCalculation/?id=${state}`,
            {
              headers: authHeader(),
            }
          );
          responsepay.then((response) => {
            {
              setPaymentDeatil(response.data.response);
            }
          });
          // setPaymentDeatil(responsepay.data.response)
        } catch (error) {
          console.error("Error fetching payment data:", error);
        }
      } else {
        console.log("response data in else",);
        // setPaymentDeatil(
        //    Helper.calculatedLoanPaymentDates(
        //     start_date,
        //     paymentrule,
        //     payment_count,
        //     paymentfrequency,
        //     contract_term,
        //     response.data,
        //     feedefination,
        //     contract_type
        //   )
        // );
      }
      // setPaymentDeatil(
      //   Helper.calculatedLoanPaymentDates(
      //     start_date,
      //     paymentrule,
      //     payment_count,
      //     paymentfrequency,
      //     contract_term,
      //     response.data,
      //     feedefination,
      //     contract_type
      //   )
      // );
      // var sumOfRentAmount = 0;
      // var sumofNoofpayment = 0;
      // if (contract_type === "Loan") {
      //   for (let rent in response.data) {
      //     if (response.data[rent].payment_type === "Rent") {
      //       sumOfRentAmount += response.data[rent].amount;
      //       sumofNoofpayment += response.data[rent].periods;
      //     }
      //   }
      // } else {
      //   for (let rent in response.data) {
      //     if (response.data[rent].payment_type === "Rent") {
      //       sumOfRentAmount += response.data[rent].amount;
      //       sumofNoofpayment += response.data[rent].no_of_payments;
      //     }
      //   }
      // }

      // setRentAmount(sumOfRentAmount);
      // switch (paymentfrequency) {
      //   case "Monthly":
      //     setNumberofpayment(sumofNoofpayment);
      //     break;
      //   case "Quarterly":
      //     setNumberofpayment(sumofNoofpayment * 3);
      //     break;
      //   case "Annual":
      //     setNumberofpayment(sumofNoofpayment * 12);
      //     break;
      //   case "Semi-annual":
      //     setNumberofpayment(sumofNoofpayment * 6);
      //     break;
      //   default:
      //     setNumberofpayment(sumofNoofpayment);
      // }
      // setRefreshPaymentDetails(false);
      var sumOfRentAmount = 0;
      var sumofNoofpayment = 0;
      let rentAmounts = [];
      response.data.forEach((rentItem) => {
        if (rentItem.payment_type === "Rent") {
          sumOfRentAmount = rentItem.amount;
          sumofNoofpayment += rentItem.no_of_payments;

          let interval;
          switch (paymentfrequency) {
            case "Quarterly":
              interval = 3;
              break;
            case "Semi-annual":
              interval = 6;
              break;
            case "Annual":
              interval = 12;
              break;
            default:
              interval = 1;
          }

          if (paymentrule == "Advance") {
            for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
              if (i % interval === 0) {
                rentAmounts.push(rentItem.amount);
              } else {
                rentAmounts.push(0);
              }
            }
          } else {
            for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
              if ((i + 1) % interval === 0) {
                rentAmounts.push(rentItem.amount);
              } else {
                rentAmounts.push(0);
              }
            }
          }
        }
      });

      setRentAmount(rentAmounts);
      switch (paymentfrequency) {
        case "Monthly":
          setNumberofpayment(sumofNoofpayment);
          break;
        case "Quarterly":
          setNumberofpayment(sumofNoofpayment * 3);
          break;
        case "Annual":
          setNumberofpayment(sumofNoofpayment * 12);
          break;
        case "Semi-annual":
          setNumberofpayment(sumofNoofpayment * 6);
          break;
        default:
          setNumberofpayment(sumofNoofpayment);
      }
      setRefreshPaymentDetails(false);

    });
    fetchPaymentData();
  };
  const TotalIncome = amortcalcu.reduce((total, row) => {
    return total + row.income;
  }, 0);

  useEffect(() => {
    setLoading(true);
    setIsLoading(true);
    setIsApiUpdating(true);
    EditContractLoanService.getContract(state).then((response) => {
      setKey(response.data);
      setContract_number(response.data.contract_number);
      setStart_date(response.data.start_date);
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setPaymentStartDate(response.data.paymentstartdate);
      setCustomer_name(response.data.customer_name);
      setDeposit_amount(response.data.deposit_amount);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setIir(response.data.iir);
      setStatus(response.data.status);
      setConract(response.data);
      setPaymentRule(response.data.paymentrule);
      setPaymentFrequency(response.data.paymentfrequency);
      setTimeCountingMethod(response.data.timecountingmethod);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setLoanAmount(response.data.loanamount);
      setPaymentMethod(response.data.paymentmethod);
      setInterestCalculationMethod(response.data.interestcalculationmethod);
      setInterestpostingFrequency(response.data.interestpostingfrequency);
      setRepaymentProcedure(response.data.repaymentprocedure);
      setAsset_count(response.data.asset_count);
      setPayment_count(response.data.payment_count);
      setTotalRent(response.data.payment_rent_sum);
      setTotalOneTimeFee(response.data.one_time_fee_sum);
      setAchPayments(response.data.enable_ach || false);
      setAchAccount(response.data.ach_account_id || "");
      setAppOriginator(response.data.appOriginator || "");
      setSource(response.data.source || "");
      setSalesRep(response.data.salesRep || "");
      setSubcompany(
        response.data.subcompany ? parseInt(response.data.subcompany) : ""
      );
      setLineOfBusiness(
        response.data.line_of_business
          ? parseInt(response.data.line_of_business)
          : ""
      );
      setInterestOnlyPayments(response.data.interest_only_payments);
      setInterestRateType(response.data.interest_rate_type || "Fixed");
      setBaseRate(response.data.base_rate || 0);
      setMargin(response.data.margin || 0);
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);
      setIsLoading(false);
      setLoading(false);

      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
        paymentstartdate: response.data.paymentstartdate,
        achPayments: response.data.enable_ach || false,
        achAccount: response.data.ach_account_id || "",
        subcompany: response.data.subcompany
          ? String(response.data.subcompany)
          : "",
        lineOfBusiness: response.data.line_of_business
          ? String(response.data.line_of_business)
          : "",
      });
      if (response.data.party) {
        fetchAchAccounts(
          response.data.party,
          response.data.ach_account_id,
          (response.data.enable_ach =
            response.data.enable_ach === "Y" ? true : false), // use contract flag
          response.data.enable_ach
        ); // Fetch ACH accounts for the initial customer
      }
      fetchInterestOnlyData(state, response.data.start_date);
      fetchSubcompanies();
      fetchLinesOfBusiness();
      handlepaymentdetailview();
      setIsApiUpdating(false);
    });
  }, []);

  useEffect(() => {
    data_count();
    setTimeout(() => {
      getaddress();
    }, 1000);
  }, [selectedValue]);

  const handlecl = () => {
    setIsLoading(true);
    setLoading(true);
    setIsApiUpdating(true);
    EditContractLoanService.getContract(state).then((response) => {
      setContract_number(response.data.contract_number);
      setStart_date(response.data.start_date);
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setPaymentStartDate(response.data.paymentstartdate);
      setCustomer_name(response.data.customer_name);
      setDeposit_amount(response.data.deposit_amount);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setIir(response.data.iir);
      setStatus(response.data.status);
      setConract(response.data);
      setTimeCountingMethod(response.data.timecountingmethod);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setLoanAmount(response.data.loanamount);
      setPaymentMethod(response.data.paymentmethod);
      setPaymentRule(response.data.paymentrule);
      setPaymentFrequency(response.data.paymentfrequency);
      setInterestCalculationMethod(response.data.interestcalculationmethod);
      setInterestpostingFrequency(response.data.interestpostingfrequency);
      setRepaymentProcedure(response.data.repaymentprocedure);
      setAsset_count(response.data.asset_count);
      setPayment_count(response.data.payment_count);
      setTotalRent(response.data.payment_rent_sum);
      setTotalOneTimeFee(response.data.one_time_fee_sum);
      setAchPayments(response.data.enable_ach || false);
      setAchAccount(response.data.ach_account_id || "");
      setAppOriginator(response.data.appOriginator || "");
      setSource(response.data.source || "");
      setSalesRep(response.data.salesRep || "");
      setSubcompany(
        response.data.subcompany ? String(response.data.subcompany) : ""
      );
      setLineOfBusiness(
        response.data.line_of_business
          ? String(response.data.line_of_business)
          : ""
      );
      setInterestOnlyPayments(response.data.interest_only_payments);
      setInterestRateType(response.data.interest_rate_type || "Fixed");
      setBaseRate(response.data.base_rate || 0);
      setMargin(response.data.margin || 0);
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);

      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
        paymentstartdate: response.data.paymentstartdate,
        achPayments: response.data.enable_ach || false,
        achAccount: response.data.ach_account_id || "",
        subcompany: response.data.subcompany
          ? parseInt(response.data.subcompany)
          : "",
        lineOfBusiness: response.data.line_of_business
          ? parseInt(response.data.line_of_business)
          : "",
      });
      if (response.data.party) {
        fetchAchAccounts(
          response.data.party,
          response.data.ach_account_id,
          (response.data.enable_ach =
            response.data.enable_ach === "Y" ? true : false), // use contract flag
          response.data.enable_ach
        ); // Fetch ACH accounts for the initial customer
      }
      fetchInterestOnlyData(state, response.data.start_date);
      fetchSubcompanies();
      fetchLinesOfBusiness();
      handlepaymentdetailview();
      setLoading(false);
      // setTimeout(() => {
      setIsLoading(false);
      setIsApiUpdating(false);
      // }, 1000);
    });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} 00:00:00`;
  };

  const handleactivation = () => {
    // if (Helper.Dateview(start_date) <= Helper.Dateview(formatDate(new Date()))) {
    if (new Date(start_date) <= new Date()) {
      handleActivate();
    } else {
      confirmAlert({
        title: "",
        message: "Contract starts on a future date. Confirm activation",
        buttons: [
          {
            label: "Continue and Activate",
            onClick: () => handleActivate(),
          },
          {
            label: "Cancel",
          },
        ],
      });
    }
  };
  console.log("paymentdetail", paymentdetail);
  const [disablecontractactive, setDisableCOntractActive] = useState(false);
  const handleActivate = () => {
    setActiveLoading(true);
    setDisableCOntractActive(true);
    ActivateContractLoanService.activateContract(
      state,
      paymentdetail,
      amortcalcu
    ).then((response) => {
      if (response.data.success) {
        setSuccessful(true);
        setActiveLoading(false);
        setTimeout(() => {
          navigate("/contract");
          setDisableCOntractActive(false);
        }, 2000);
        toast.success(`${response.data.response}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(`${response.data.error}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setDisableCOntractActive(false);
        setSuccessful(false);
      }
    });
  };

  let navigate = useNavigate();

  const [disablecontract, setDisableContract] = useState(false);
  const handleRegister = (id) => {
    setSuccessful(false);
    setLoading(true);
    setDisableContract(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      try {
        EditContractLoanService.editContract(
          state,
          contract_number,
          contract_term,
          Helper.DatePicker(start_date),
          Helper.DatePicker(end_date),
          Helper.DatePicker(paymentstartdate),
          address_id,
          contract_type,
          loanamount,
          iir,
          interestcalculationmethod,
          repaymentprocedure,
          timecountingmethod,
          paymentmethod,
          deposit_amount,
          feesontime,
          tax_rate_rent,
          tax_rate_fee,
          selectedValue,
          attribute,
          paymentfrequency,
          paymentrule,
          achPayments,
          achAccount,
          appOriginator,
          source,
          salesRep,
          subcompany,
          lineOfBusiness,
          interest_only_payments,
          "",
          interestRateType,
          baseRate,
          margin
        )
          .then((response) => {
            if (response.data.success) {
              setSuccessful(true);
              setLoading(false);
              setTimeout(() => {
                handlecl();
                handlepayment();
                saveInterestOnly(state)
                setDisableContract(false);
              }, 2000);
              toast.success(`${response.data.response}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else {
              toast.error(`${response.data.error}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setSuccessful(false);
            }
            setLoading(false);
            setDisableContract(false);
          })
          .catch((error) => {
            setLoading(false);
            setDisableContract(false);
            setSuccessful(false);
          });
      } catch (e) {
        setLoading(false);
        setSuccessful(false);
        setDisableContract(false);
      }
    } else {
      setLoading(false);
      setDisableContract(false);
      toast.error(
        "Something went wrong, Please log a support ticket or send email to support@athenafintech.com",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
  };

  useEffect(() => {
    getExtrafiled();
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...attribute];
    rowsInput[index][name] = value;
    setAttribute(rowsInput);
  };

  useEffect(() => {
    if (contract.length !== 0) {
      handlepaymentdetailview();
    }
    if (refreshdetail === true) {
      handlepaymentdetailview();
    }
  }, [contract, refreshdetail]);

  useEffect(() => {
    if (paymentdetail.length === 0) {
      SetAmortCalculation([]);
    }
    if (paymentdetail.length !== 0) {
      // if (numberofpayment && rentamount > 0) {
      if (numberofpayment && rentamount.length > 0) {
        if (paymentrule === "Advance") {

          try {
            const response = axios.get(
              `${API}contracts/amortCalculation/?id=${state}`,
              {
                headers: authHeader(),
              }
            );
            // response.then((response )=>{{SetAmortCaluculation(response.data.response)}console.log("data---",response.data.response)})
            response.then((response) => {
              {
                SetAmortCalculation(response.data.response);
                // SetCalu(response.data.response);
              }
            });
          } catch (error) {
            console.error("Error fetching payment data:", error);
          }
          // SetAmortCalculation(
          //   Helper.generateSchedule(
          //     start_date,
          //     numberofpayment,
          //     loanamount,
          //     rentamount,
          //     paymentfrequency,
          //     iir,
          //     residual
          //   )
          // );
        } else {
          try {
            const response = axios.get(
              `${API}contracts/amortCalculation/?id=${state}`,
              {
                headers: authHeader(),
              }
            );
            // response.then((response )=>{{SetAmortCaluculation(response.data.response)}console.log("data---",response.data.response)})
            response.then((response) => {
              // SetCalu(response.data.response);
              SetAmortCalculation(response.data.response);
            });
          } catch (error) {
            console.error("Error fetching payment data:", error);
          }
          // SetAmortCalculation(
          //   Helper.generateArrearsSchedule(
          //     start_date,
          //     numberofpayment,
          //     loanamount,
          //     rentamount,
          //     paymentfrequency,
          //     iir,
          //     residual
          //   )
          // );
        }
      }
    }
  }, [numberofpayment, rentamount, loanamount, paymentrule, iir, start_date]);

  const clickontab = () => {
    handlecl();
    handlepaymentdetailview();
  };

  const loadOptionBillAdd = async (inputValue, callback) => {
    const filteredOptions = address
      .filter((address) =>
        `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      )
      .map((address) => ({
        value: address.id,
        label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
      }));

    setFilterBill(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
    }));
    setFilterBill(options);
  }, [address]);

  const handleBillAddressChange = (selectedOption) => {
    if (selectedOption) {
      setAdddressId(selectedOption.value);
      setSelectedBill(selectedOption.value);

      reset({ address: selectedOption.value });
    } else {
      setAdddressId(null);
      setSelectedBill(null);
      reset({ address: null });
    }
  };

  // const totalIncome = amortcalcu.reduce((sum, val) => sum + val.income, 0);

  const totalIncome = (amortcalcu || []).reduce(
    (sum, val) => sum + (val.income || 0),
    0
  );


  const addTableRows = () => {
    setAddTable(true);
    let startDate = new Date(start_date);

    let paymentstartDate;
    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstartdate);
    }
    let endDate = new Date(startDate);
    if (paymentfrequency === "Monthly") {
      endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
      endDate.setDate(endDate.getDate() - 1);
    } else if (paymentfrequency === "Quarterly") {
      endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
      endDate.setDate(endDate.getDate() - 1);
    } else if (paymentfrequency === "Semi-annual") {
      endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
      endDate.setDate(endDate.getDate() - 1);
    } else if (paymentfrequency === "Annual") {
      endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
      endDate.setDate(endDate.getDate() - 1);
    }
    const rowsInput = {
      no_of_payments: 1,
      payment_type: "Origination Fee",
      payment_frequency: paymentfrequency,
      start_date: Helper.DatePicker(startDate),
      end_date: Helper.DatePicker(endDate),
      paymentstart_date: Helper.DatePicker(paymentstartDate),
      amount: null,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    setTermError("");
  };

  const handlePayment = () => {
    const term = rowsData.map((val) => val.no_of_payments);
    const amount = rowsData.map((val) => val.amount);
    setTermError("");

    let contractTerm = null;
    if (paymentfrequency === "Monthly") {
      contractTerm = contract_term / frequencyMapped.Monthly;
    } else if (paymentfrequency === "Quarterly") {
      contractTerm = contract_term / frequencyMapped.Quarterly;
    } else if (paymentfrequency === "Semi-annual") {
      contractTerm = contract_term / frequencyMapped.SemiAnnual;
    } else if (paymentfrequency === "Annual") {
      contractTerm = contract_term / frequencyMapped.Annual;
    }
    const totalPayments = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);
      return row.payment_type === "Rent"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);

    // const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
    //   const payments = parseInt(row.no_of_payments, 10);
    //   return row.payment_type === 'Maintenance Fee' ? sum + (isNaN(payments) ? 0 : payments) : sum;
    // }, 0);
    let rowContractTerm = null;
    const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);

      if (row.payment_type === "Maintenance Fee") {
        if (row.payment_frequency === "Monthly") {
          rowContractTerm = contract_term / frequencyMapped.Monthly;
        } else if (row.payment_frequency === "Quarterly") {
          rowContractTerm = contract_term / frequencyMapped.Quarterly;
        } else if (row.payment_frequency === "Semi-annual") {
          rowContractTerm = contract_term / frequencyMapped.SemiAnnual;
        } else if (row.payment_frequency === "Annual") {
          rowContractTerm = contract_term / frequencyMapped.Annual;
        }
      }

      return row.payment_type === "Maintenance Fee"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);

    if (term.includes("") || term.includes(0)) {
      setTermError("No of payment is required");
      return;
    }
    if (amount.includes("") || amount.includes(null)) {
      setTermError("Amount is required");
      return;
    }

    const negativeAmount = amount.some((a) => parseFloat(a) < 0);
    if (negativeAmount) {
      setTermError("Only positive numbers are allowed");
      return;
    }

    if (totalPayments !== contractTerm) {
      setTermError(`Total number of Rent term ${contractTerm} is required`);
      return;
    }

    if (totalPaymentsMaintentence > rowContractTerm) {
      setTermError(
        `Total number of Maintenance term ${rowContractTerm} is required`
      );
      return;
    }
    const originationFeeCount = rowsData.filter(
      (row) => row.payment_type === "Origination Fee"
    ).length;
    if (originationFeeCount > 1) {
      setTermError("Origination Fee can only be added once.");
      return;
    }

    const documentationFeeCount = rowsData.filter(
      (row) => row.payment_type === "Documentation Fee"
    ).length;
    if (documentationFeeCount > 1) {
      setTermError("Documentation Fee can only be added once.");
      return;
    }

    if (!termError) {
      setTimeout(() => {
        handleRegister();
      }, 1000);
    } else {
      setRowsData([...rowsData]);
    }
  };

  const fetchPaymentData = async () => {
    try {
      const response = await axios.get(
        `${API}contracts/payment-view/${state}/`,
        {
          headers: authHeader(),
        }
      );
      const rowValue = response.data;
      const rowsInput = rowValue.map((val) => ({
        no_of_payments: val.no_of_payments,
        payment_frequency: val.frequency,
        start_date: Helper.DatePicker(val.start_date),
        end_date: Helper.DatePicker(val.end_date),
        payment_type: val.payment_type,
        amount: val.amount,
      }));
      setRowsData(rowsInput);
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  };
  useEffect(() => {
    fetchPaymentData();
  }, []);

  const handleTermChange = (index, value) => {
    const termMonths = parseInt(value);
    const updatedRowsData = [...rowsData];
    const currentType = updatedRowsData[index].payment_type;
    let startDate = new Date(start_date);
    let paymentstartDate = new Date(start_date);

    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstartdate);
    }
    setTermError("");
    if (currentType === "Rent") {
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      if (paymentfrequency === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Rent"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
              // if(paymentrule === 'Advance'){
              //    startDate = new Date(start_date)
              //   }else{
              //     startDate = new Date(paymentstartdate)
              // }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Rent") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
                paymentstartDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule ==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + termMonths);
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);

            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (paymentfrequency === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
              paymentstartDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            let paymentstartDate;

            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    } else if (currentType === "Maintenance Fee") {
      let frequencyData;
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      frequencyData = updatedRowsData[index].payment_frequency;

      if (frequencyData === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Maintenance Fee"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
              if (paymentrule === "Advance") {
                paymentstartDate = new Date(start_date);
              } else {
                paymentstartDate = new Date(paymentstartdate);
              }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);
            updatedRowsData[index].payment_frequency = "Monthly";
            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (frequencyData === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
              //   if(paymentrule === 'Advance'){
              //     startDate = new Date(start_date)

              //    }else{

              //      startDate = new Date(paymentstartdate)
              //  }
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    }
  };

  const handlePaymentTypeChange = (index, event) => {
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].payment_frequency = paymentfrequency;

    // updatedRowsData[index].payment_type = event;
    // const restrictedTypes = ['Origination Fee', 'Documentation Fee', 'Maintenance Fee'];
    const restrictedTypes = ["Origination Fee", "Documentation Fee"];
    if (restrictedTypes.includes(event)) {
      const paymentTypeExists = updatedRowsData.some(
        (row, idx) => row.payment_type === event && idx !== index
      );

      if (paymentTypeExists) {
        setTermError(`${event} can only have one entry.`);
        return;
      }
    }
    updatedRowsData[index].payment_type = event;

    if (event === "Origination Fee" || event === "Documentation Fee") {
      const contractTerm = contract_term / frequencyMapped.Monthly;
      let startDate = new Date(start_date);
      let paymentstartDate;

      if (paymentrule === "Advance") {
        paymentstartDate = new Date(start_date);
      } else {
        paymentstartDate = new Date(paymentstartdate);
      }
      let endDate = new Date(startDate);
      // const month = frequencyMapped.Annual * contractTerm;
      if (paymentfrequency === "Monthly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Quarterly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Semi-annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      }
    } else if (event === "Rent") {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    } else {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    }

    setRowsData(updatedRowsData);
  };

  const handlePaymentFrequencyChange = (index, selectedValue) => {
    let updatedRowsData = [...rowsData];
    let startDate = new Date(start_date);
    let paymentstartDate;
    updatedRowsData[index].payment_frequency = paymentfrequency;

    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstartdate);
    }
    if (updatedRowsData[index].payment_type === "Maintenance Fee") {
      let contractTerm = null;
      if (selectedValue === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
      } else if (selectedValue === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
      } else if (selectedValue === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
      } else if (selectedValue === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
      }

      updatedRowsData[index].no_of_payments = "";
      updatedRowsData[index].start_date = Helper.DatePicker(startDate);
      updatedRowsData[index].payment_frequency = selectedValue;
      updatedRowsData[index].paymentstart_date =
        Helper.DatePicker(paymentstartDate);
      updatedRowsData[index].end_date = "";
      const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
        const payments = parseInt(row.no_of_payments, 10);
        return row.payment_type === "Maintenance Fee"
          ? sum + (isNaN(payments) ? 0 : payments)
          : sum;
      }, 0);
      if (totalPaymentsMaintentence > contractTerm) {
        setTermError(
          `Total number of Maintenance term ${contractTerm} is required`
        );
        return;
      }
    } else {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    }
    setRowsData(updatedRowsData);
  };

  const handelChangeAmount = (index, event) => {
    setTermError("");
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].amount = event;

    setRowsData(updatedRowsData);
  };

  const isDisabled = rowsData.length > 1;

  useEffect(() => {
    // if (dataFetched && amount !== null && amount > 0 && amount !== undefined && contract_term !== '') {
    if (dataFetched && contract_term !== "") {
      let contractTerm = null;
      let startDate;
      let endDate;
      let paymentstartDate;

      if (paymentfrequency === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + contractTerm);
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.Quarterly * contractTerm;
        endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.SemiAnnual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month);
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.Annual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month);
        endDate.setDate(endDate.getDate() - 1);
      }

      const rentRow = {
        no_of_payments: contractTerm,
        payment_type: "Rent",
        payment_frequency: paymentfrequency,
        start_date: Helper.DatePicker(startDate),
        end_date: Helper.DatePicker(endDate),
        amount: amount,
        paymentstart_date: Helper.DatePicker(paymentstartDate),
      };
      setRowsData((prevRowsData) => {
        const updatedRows = prevRowsData
          .filter((row) => row.payment_type !== "Rent")
          .map((row) => {
            if (row.payment_type === "Origination Fee") {
              let maintenanceStartDate = new Date(start_date);
              let maintenanceEndDate = new Date(maintenanceStartDate);
              let originationTerm = row.no_of_payments;
              if (paymentfrequency === "Monthly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Monthly;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + originationTerm
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Quarterly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                const month = frequencyMapped.Quarterly * originationTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Semi-annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                const month = frequencyMapped.SemiAnnual * originationTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Annual") {
                const month = frequencyMapped.Annual * originationTerm;
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              }

              return {
                ...row,
                start_date: Helper.DatePicker(maintenanceStartDate),
                end_date: Helper.DatePicker(maintenanceEndDate),
                paymentstart_date: Helper.DatePicker(paymentstartDate),
                payment_frequency: paymentfrequency,
              };
            }
            if (row.payment_type === "Documentation Fee") {
              let maintenanceStartDate = new Date(start_date);
              let maintenanceEndDate = new Date(maintenanceStartDate);
              let originationTerm = row.no_of_payments;
              if (paymentfrequency === "Monthly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Monthly;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + originationTerm
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Quarterly") {
                const month = frequencyMapped.Quarterly * originationTerm;
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Semi-annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                const month = frequencyMapped.SemiAnnual * originationTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                const month = frequencyMapped.Annual * originationTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              }

              return {
                ...row,
                start_date: Helper.DatePicker(maintenanceStartDate),
                end_date: Helper.DatePicker(maintenanceEndDate),
                paymentstart_date: Helper.DatePicker(paymentstartDate),
                payment_frequency: paymentfrequency,
              };
            }
            if (row.payment_type === "Maintenance Fee") {
              let maintenanceStartDate = new Date(start_date);
              let maintenanceEndDate = new Date(maintenanceStartDate);

              if (paymentfrequency === "Monthly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Monthly;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + contractTerm
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Quarterly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Quarterly;
                const month = frequencyMapped.Quarterly * contractTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Semi-annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.SemiAnnual;
                const month = frequencyMapped.SemiAnnual * contractTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Annual;
                const month = frequencyMapped.Annual * contractTerm;

                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              }

              return {
                ...row,
                // no_of_payments: contractTerm,
                start_date: Helper.DatePicker(maintenanceStartDate),
                end_date: Helper.DatePicker(maintenanceEndDate),
                paymentstart_date: Helper.DatePicker(paymentstartDate),
                payment_frequency: paymentfrequency,
              };
            }
            return row;
          });

        return [...updatedRows, rentRow];
      });
    }
  }, [
    amount,
    paymentfrequency,
    paymentrule,
    paymentstartdate,
    contract_term,
    frequencyMapped,
    start_date,
    dataFetched,
    state,
  ]);

  const handleTabClick = (index) => {
    setTabContractIndex(index);
  };



  // ----------------- Interest Only -----------------
  const [isInterestOnly, setIsInterestOnly] = useState(false);
  const [interestOnlyType, setInterestOnlyType] = useState(""); // BILL | CAPITALIZE
  const [interestOnlyPeriods, setInterestOnlyPeriods] = useState(0);

  // BILL
  const [billedRows, setBilledRows] = useState([]);

  // CAPITALIZE
  const [capitalizeDays, setCapitalizeDays] = useState(0);
  const [capitalizedInterestRate, setCapitalizedInterestRate] = useState(iir);
  const [dayConvention, setDayConvention] = useState("Actual/360");
  const [capitalizedInterest, setCapitalizedInterest] = useState(0);
  const [totalLoanAmount, setTotalLoanAmount] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState("0.00");

  const calculateInterestAmount = (principal, rate, days, convention) => {
    if (!principal || !rate) return "0.00";

    let yearBase = 360;
    if (convention === "Actual/365") yearBase = 365;
    if (convention === "Actual/360") yearBase = 360;
    if (convention === "30/360") {
      // days = 30;
      if (interestOnlyType === "CAPITALIZE") {
        days = capitalizeDays;
      }
      else {

        days = 30;
      }
    }

    return (
      (principal * (rate / 100) * days) / yearBase
    ).toFixed(2);
  };

  // const calculatePMT = (principal, annualRate, term, frequency) => {
  //   if (!principal || !annualRate || !term) return 0;

  //   const frequencyMap = {
  //     Monthly: 12,
  //     Quarterly: 4,
  //     "Semi-annual": 2,
  //     Annual: 1,
  //   };

  //   const periodsPerYear = frequencyMap[frequency] || 12;

  //   const periodicRate = annualRate / 100 / periodsPerYear;

  //   const totalPeriods = term * (12 / periodsPerYear);

  //   if (periodicRate === 0) {
  //     return principal / totalPeriods;
  //   }

  //   const pmt =
  //     (principal *
  //       periodicRate *
  //       Math.pow(1 + periodicRate, totalPeriods)) /
  //     (Math.pow(1 + periodicRate, totalPeriods) - 1);

  //   return pmt;
  // };

  // const calculatePMT = (principal, annualRate, term, frequency) => {
  //   // term = contract_term in MONTHS
  //   if (!principal || !term) return 0;

  //   const frequencyMap = {
  //     Monthly: 12,
  //     Quarterly: 4,
  //     "Semi-annual": 2,
  //     Annual: 1,
  //   };

  //   const periodsPerYear = frequencyMap[frequency] || 12;

  //   // ✅ number of total payment periods
  //   const totalPeriods = term / (12 / periodsPerYear);

  //   if (totalPeriods === 0) return 0;

  //   // ✅ periodic interest rate
  //   const periodicRate = (annualRate || 0) / 100 / periodsPerYear;

  //   // ✅ If interest rate = 0
  //   if (periodicRate === 0) {
  //     return Number((principal / totalPeriods).toFixed(6));
  //   }

  //   // ✅ Standard PMT formula (clean version)
  //   const pmt =
  //     (principal * periodicRate) /
  //     (1 - Math.pow(1 + periodicRate, -totalPeriods));

  //   return Number(pmt.toFixed(6));
  // };
  const calculatePMT = (principal, annualRate, term, frequency) => {

    if (!principal || !term) return 0;

    const frequencyMap = {
      Monthly: 12,
      Quarterly: 4,
      "Semi-annual": 2,
      Annual: 1,
    };

    const periodsPerYear = frequencyMap[frequency] || 12;
    console.log("Periods Per Year:", periodsPerYear);
    const totalPeriods = term / (12 / periodsPerYear);
    console.log("Total Periods:", totalPeriods);
    if (!totalPeriods) return 0;

    const principalNum = parseFloat(principal) || 0;
    const rateNum = parseFloat(annualRate);

    const periodicRate =
      !rateNum || rateNum === 0
        ? 0
        : rateNum / 100 / periodsPerYear;

    // ✅ ZERO INTEREST CASE
    if (periodicRate === 0) {
      console.log("Zero interest case. Principal:", principalNum, "Total Periods:", totalPeriods);
      let pmt = principalNum / totalPeriods;
      console.log("Zero interest PMT:", pmt);
      return Number(pmt.toFixed(6));
      // return Number((principalNum / totalPeriods).toFixed(6));
    }

    // ✅ STANDARD PMT
    const pmt =
      (principalNum * periodicRate) /
      (1 - Math.pow(1 + periodicRate, -totalPeriods));

    console.log("Calculated PMT:", pmt);

    return Number(pmt.toFixed(6));
  };

  useEffect(() => {
    if (interestOnlyType !== "CAPITALIZE") return;

    const interest = calculateInterestAmount(
      loanamount,
      capitalizedInterestRate,
      capitalizeDays,
      dayConvention
    );

    setCapitalizedInterest(interest);
    setTotalLoanAmount(
      (parseFloat(loanamount || 0) + parseFloat(interest)).toFixed(2)
    );

  }, [
    loanamount,
    capitalizedInterestRate,
    capitalizeDays,
    dayConvention,
    interestOnlyType
  ]);

  const daysBetween = (from, to) => {
    const start = new Date(from);
    const end = new Date(to);

    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    // 🔑 Finance rule: end date NOT included
    return Math.round(
      (end - start) / (1000 * 60 * 60 * 24)
    );
  };
  const daysBetweenInclusive = (start, end) =>
    Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;

  const getBaseInterestDate = () => {
    const start = new Date(start_date);
    start.setHours(0, 0, 0, 0);

    if (paymentrule === "Advance") {
      return start;
    }

    // Arrears → move by frequency
    const freqMap = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const months = freqMap[paymentfrequency] || 1;
    const d = new Date(start);
    d.setMonth(d.getMonth() + months);

    return d;
  };
  const fetchInterestOnlyData = async (contractId, startDate) => {
    try {
      const res = await axios.get(
        `${API}contracts/interest-only/?contract_id=${contractId}`,
        { headers: authHeader() }
      );

      if (!res.data || !res.data.rows?.length) {
        setIsInterestOnly(false);
        return;
      }

      const { interest_only_type, rows } = res.data;

      setIsInterestOnly(true);
      setInterestOnlyType(interest_only_type);
      const frequencyMonthsMap = {
        Monthly: 1,
        Quarterly: 3,
        "Semi-annual": 6,
        Annual: 12,
      };
      // const cycleMonths = frequencyMonthsMap[paymentFrequencystep] || 1;

      // const baseDate = calculateBasePaymentStartDate();
      // if (!baseDate) return;
      const cycleMonths = frequencyMonthsMap[paymentfrequency] || 1;

      // Base date depends on payment rule
      const baseDate =
        paymentrule === "Advance"
          ? new Date(startDate)
          : new Date(startDate);
      // let periodStart = new Date(baseDate);
      if (interest_only_type === "BILL") {
        setInterestOnlyPeriods(rows.length);

        const billed = rows.map((r, index) => {
          const { start, end } = getPeriodStartAndEnd(
            baseDate,
            index,
            cycleMonths
          );

          const periodDays = daysBetweenInclusive(start, end);

          return {
            period: r.period_no,
            interestRate: r.interest_rate,
            periodDays, // ✅ DIFFERENT per row
            dayConvention: r.day_convention,
            billAmount: r.bill_amount,
            // billAmount: calculateInterestAmount(
            //   loanamount,
            //   r.interest_rate,
            //   periodDays,
            //   r.day_convention
            // ),
          };
        });

        setBilledRows(billed);
      }
      // if (interest_only_type === "BILL") {
      //   const periodDays = calculatePeriodDays(row, index);
      //   // const periodEnd = addMonthsSafe(periodStart, cycleMonths);
      //   // const periodDays = daysBetween(periodStart, periodEnd);
      //   setInterestOnlyPeriods(rows.length);
      //   setBilledRows(
      //     rows.map(r => ({
      //       period: r.period_no,
      //       interestRate: r.interest_rate,
      //       periodDays: periodDays,
      //       dayConvention: r.day_convention,
      //       billAmount: r.bill_amount,
      //     }))
      //   );
      // }

      if (interest_only_type === "CAPITALIZE") {
        const row = rows[0];
        setCapitalizeDays(row.capitalize_interest_days);
        setCapitalizedInterestRate(row.interest_rate || iir);
        setDayConvention(row.day_convention);
        setCapitalizedInterest(row.capitalized_interest);
        setTotalLoanAmount(row.total_loan_amount);
        setPaymentAmount(row.payment_amount);
      }

    } catch (err) {
      console.error("Interest only fetch failed", err);
    }
  };

  const normalizeDate = (d) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const getBasePaymentStartDate = () => {
    if (!start_date) return null;

    const contractDate = new Date(start_date);
    if (isNaN(contractDate)) return null;

    const frequencyMapping = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const monthsToAdd = frequencyMapping[paymentfrequency] || 0;

    // Advance → payment on contract date
    if (paymentrule === "Advance") {
      const d = new Date(contractDate);
      d.setHours(0, 0, 0, 0);
      return d;
    }

    // ---------- ARREARS (SAFE MONTH HANDLING) ----------
    const originalDay = contractDate.getDate();

    // Step 1: move to first of month (prevents overflow)
    const base = new Date(contractDate);
    base.setDate(1);

    // Step 2: add months
    base.setMonth(base.getMonth() + monthsToAdd);

    // Step 3: find last day of target month
    const lastDayOfMonth = new Date(
      base.getFullYear(),
      base.getMonth() + 1,
      0
    ).getDate();

    // Step 4: clamp day
    base.setDate(Math.min(originalDay, lastDayOfMonth));
    base.setHours(0, 0, 0, 0);

    return base;
  };
  // const getBasePaymentStartDate = () => {
  //     if (!start_date) return null;

  //     const contractDateObj = new Date(start_date);

  //     const frequencyMapping = {
  //         Monthly: 1,
  //         Quarterly: 3,
  //         "Semi-annual": 6,
  //         Annual: 12,
  //     };

  //     const monthsToAdd = frequencyMapping[paymentfrequency] || 0;

  //     if (paymentrule === "Advance") {
  //         return new Date(contractDateObj);
  //     }

  //     // Arrears - first payment date after one cycle
  //     let base = new Date(contractDateObj);

  //     // Add the correct number of months (handles year rollover safely)
  //     base.setMonth(base.getMonth() + monthsToAdd);
  //     base.setHours(0, 0, 0, 0)

  //     const originalDay = contractDateObj.getDate();

  //     // If adding months caused day overflow (e.g. Jan 31 → Feb 28/29/30)
  //     // → move to the last valid day of the target month
  //     if (base.getDate() < originalDay) {
  //         // Set to last day of the current month
  //         base.setDate(0); // day 0 = last day of previous month
  //         base.setHours(0, 0, 0, 0); // normalize time
  //     }

  //     return base;
  // };

  const calculateCalendarDays = (start, end) => {
    const startUTC = Date.UTC(
      start.getFullYear(),
      start.getMonth(),
      start.getDate()
    );

    const endUTC = Date.UTC(
      end.getFullYear(),
      end.getMonth(),
      end.getDate()
    );

    return Math.floor((endUTC - startUTC) / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    if (!start_date || !paymentstartdate) {
      setInterestOnlyPayments(0);
      setInterestOnlyType("");
      setIsInterestOnly(false);
      return;
    }
    const rawBase = getBasePaymentStartDate();
    if (!rawBase) return;

    const basePaymentDate = normalizeDate(rawBase);

    // const basePaymentDate = getBasePaymentStartDate();
    // if (!basePaymentDate) return;

    // const actualPaymentDate =
    //     paymentstartdate instanceof Date
    //         ? paymentstartdate
    //         : new Date(paymentstartdate);

    const rawActual =
      paymentstartdate instanceof Date
        ? paymentstartdate
        : new Date(paymentstartdate);

    const actualPaymentDate = normalizeDate(rawActual);

    // if (isNaN(actualPaymentDate)) {
    //     setInterestOnlyPayments(0);
    //     setInterestOnlyType("");
    //     setIsInterestOnly(false);
    //     return;
    // }
    if (actualPaymentDate.getTime() === basePaymentDate.getTime()) {
      setInterestOnlyPayments(0);
      // setInterestOnlyInDays(false);
      setIsInterestOnly(false);
      setInterestOnlyType("");
      return;
    }

    const frequencyMonthMap = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const periodMonths = frequencyMonthMap[paymentfrequency] || 1;

    // =========================
    // BILL (MONTH BASED)
    // =========================
    if (actualPaymentDate.getDate() === basePaymentDate.getDate()) {
      const totalMonths =
        (actualPaymentDate.getFullYear() - basePaymentDate.getFullYear()) * 12 +
        (actualPaymentDate.getMonth() - basePaymentDate.getMonth());

      if (totalMonths > 0 && totalMonths % periodMonths === 0) {
        const billPeriods = totalMonths / periodMonths;

        const rows = [];

        // ✅ START FROM CONTRACT DATE (FIX)
        let periodStart = normalizeDate(new Date(start_date));

        for (let i = 0; i < billPeriods; i++) {
          const periodEnd = addMonthsSafe(periodStart, periodMonths);

          // ✅ finance-correct day count
          const periodDays = daysBetween(periodStart, periodEnd);

          rows.push({
            period: i + 1,
            periodDays,
            interestRate: iir,
            dayConvention: "Actual/360",
            billAmount: calculateInterestAmount(
              loanamount,
              iir,
              periodDays,
              "Actual/360"
            ),
          });

          periodStart = periodEnd;
        }

        setBilledRows(rows);
        setIsInterestOnly(true);
        setInterestOnlyType("BILL");
        setInterestOnlyPayments(billPeriods);
        // setInterestOnlyInDays(false);
        return;
      }
    }
    // =========================
    // CAPITALIZE (DAY BASED)
    // =========================
    else {
      //     const contractStart = new Date(start_date);
      // const actualDate = new Date(paymentstartdate);

      // const days = calculateCalendarDays(contractStart, actualDate);
      // console.log("Calendar Days for Capitalization:", days); // Debug log
      // if (days ) {
      // // if (days > 0) {

      //     let yearBase = 360;
      //     if (timecountingmethod === "Actual/365") yearBase = 365;

      //     const principal = parseFloat(loanamount || loanamount || 0);
      //     const rate = parseFloat(iir || 0);

      //     const creditInterest =
      //         (principal * rate * days) / (100 * yearBase);

      //     const newPrincipal = principal + creditInterest;

      //     setIsInterestOnly(true);
      //     // setInterestOnlyType("CREDIT");   // 🔥 change label here
      //     setInterestOnlyType("CAPITALIZE");   // 🔥 change label here
      //     setInterestOnlyPayments(days);
      //     setCapitalizeDays(days);
      //     // setInterestOnlyInDays(true);

      //     setCapitalizedInterest(creditInterest.toFixed(2));
      //     setTotalLoanAmount(newPrincipal.toFixed(2));

      //     } else {
      //         setIsInterestOnly(false);
      //     }

      //     const contractStart = normalizeDate(new Date(start_date));
      // const paymentStart = normalizeDate(new Date(paymentstartdate));

      // if (!contractStart || !paymentStart) return;

      // // Monthly only (your Excel model)
      // const accrualStart = normalizeDate(
      //   new Date(
      //     paymentStart.getFullYear(),
      //     paymentStart.getMonth() - cycleMonths,
      //     paymentStart.getDate()
      //   )
      // );

      // let days = 0;

      // // CASE 1 → Normal accrual
      // if (accrualStart >= contractStart) {

      //   days = calculateCalendarDays(contractStart, accrualStart);

      // }
      // // CASE 2 → Accrual before contract start
      // else {

      //   const forwardDays = calculateCalendarDays(contractStart, paymentStart);

      //   days = 30 - forwardDays;

      // }

      // const contractStart = normalizeDate(new Date(start_date));
      // const paymentStart = normalizeDate(new Date(paymentstartdate));

      // if (!contractStart || !paymentStart) return;

      // // --------------------------------------
      // // Frequency → cycle months
      // // --------------------------------------
      // const frequencyMap = {
      //   Monthly: 1,
      //   Quarterly: 3,
      //   "Semi-annual": 6,
      //   Annual: 12,
      // };

      // const cycleMonths = frequencyMap[paymentfrequency] || 1;

      // // --------------------------------------
      // // Accrual start = payment - cycle
      // // --------------------------------------
      // let accrualStart = normalizeDate(
      //   new Date(
      //     paymentStart.getFullYear(),
      //     paymentStart.getMonth() - cycleMonths,
      //     paymentStart.getDate()
      //   )
      // );

      // console.log("Contract Start:", contractStart);
      // console.log("Payment Start:", paymentStart);
      // console.log("Accrual Start:", accrualStart);
      // let days = 0;

      // // --------------------------------------
      // // CASE 1 → Normal accrual
      // // --------------------------------------
      // if (dayConvention === "Actual/360" || dayConvention === "Actual/365") {

      //   days = calculateCalendarDays(contractStart, accrualStart);

      // }
      // // --------------------------------------
      // // 30/360 convention
      // // --------------------------------------
      // else if (dayConvention === "30/360") {

      //   const frequencyMap = {
      //     Monthly: 1,
      //     Quarterly: 3,
      //     "Semi-annual": 6,
      //     Annual: 12,
      //   };

      //   const cycleMonths = frequencyMap[paymentfrequency] || 1;

      //   const accrualStart = normalizeDate(
      //     new Date(
      //       paymentStart.getFullYear(),
      //       paymentStart.getMonth() - cycleMonths,
      //       paymentStart.getDate()
      //     )
      //   );

      //   if (accrualStart >= contractStart) {

      //     days = calculateCalendarDays(contractStart, accrualStart);

      //   } else {

      //     const forwardDays = calculateCalendarDays(contractStart, paymentStart);
      //     const cycleDays = 30 * cycleMonths;

      //     days = cycleDays - forwardDays;
      //   }
      // }

      const contractStart = normalizeDate(new Date(start_date));
      const paymentStart = normalizeDate(new Date(paymentstartdate));

      if (!contractStart || !paymentStart) return;
      const frequencyMap = {
        Monthly: 1,
        Quarterly: 3,
        "Semi-annual": 6,
        Annual: 12,
      };
      const cycleMonths = frequencyMap[paymentfrequency] || 1
      // Monthly arrears only
      const accrualStart = normalizeDate(
        new Date(
          paymentStart.getFullYear(),
          paymentStart.getMonth() - cycleMonths,
          paymentStart.getDate()
        )
      );

      let days = 0;

      console.log("dat config ", accrualStart, contractStart, accrualStart >= contractStart)

      console.log("Data <", contractStart, accrualStart, accrualStart < contractStart)
      // CASE 1 → Normal accrual
      if (accrualStart >= contractStart) {

        days = calculateCalendarDays(contractStart, accrualStart);
        console.log("Normal Accrual Days:", days);
      }
      // CASE 2 → Accrual before contract start
      else {

        // const forwardDays = calculateCalendarDays(contractStart, paymentStart);
        if (accrualStart < contractStart) {
          const calcEndDate = new Date(paymentStart);
          calcEndDate.setDate(calcEndDate.getDate() - 1);
          // const forwardDays = calculateCalendarDays(contractStart, paymentStart);
          const forwardDays = calculateCalendarDays(contractStart, calcEndDate);
          days = -(30 - forwardDays);

          // console.log("Accrual before contract start. Forward days:", forwardDays, "Calculated days:", days);
        }
        else {

          const forwardDays = calculateCalendarDays(contractStart, accrualStart);
          days = forwardDays;
          //  console.log("Accrual before contract start. Forward days:", forwardDays, "Calculated days:", days);
        }

        // console.log("Forward Days (accrual start to contract start):", contractStart, accrualStart,);

        // 30-day monthly balancing
        // days = 30 - forwardDays;
        // finance rule: use forward days directly
      }

      //     const contractStart = normalizeDate(new Date(start_date));
      // const actualPayment = normalizeDate(
      //   paymentstartdate instanceof Date
      //     ? paymentstartdate
      //     : new Date(paymentstartdate)
      // );

      // if (!contractStart || !actualPayment) return;

      // const frequencyMap = {
      //   Monthly: 1,
      //   Quarterly: 3,
      //   "Semi-annual": 6,
      //   Annual: 12,
      // };

      // const cycleMonths = frequencyMap[paymentfrequency] || 1;

      // // 🔥 Accrual Start = Payment Start - 1 cycle
      // let accrualStartDate = new Date(
      //   actualPayment.getFullYear(),
      //   actualPayment.getMonth() - cycleMonths,
      //   actualPayment.getDate()
      // );

      // accrualStartDate = normalizeDate(accrualStartDate);

      // // Excel logic = E2 - D4
      // let days = calculateCalendarDays(contractStart, accrualStartDate);

      //  const baseDate = normalizeDate(getBasePaymentStartDate());
      //  const baseDate = normalizeDate(getBasePaymentStartDate());
      // const actualDate = normalizeDate(new Date(paymentstartdate));

      // if (!baseDate || !actualDate) return;

      // // 🔥 Capitalize days = difference between actual and base
      // // let days = calculateCalendarDays(actualDate, baseDate);
      // let days = calculateCalendarDays(baseDate,actualDate);

      // console.log("Base Payment Date:", baseDate);
      // console.log("Actual Payment Date:", actualDate);
      // console.log("Calculated Capitalization Days:", days);

      // if (days <= 0) {
      //     setIsInterestOnly(false);
      //     return;
      // }

      // finance exclusive adjustment
      // days = days +1;

      let yearBase = 360;
      if (dayConvention === "Actual/365") yearBase = 365;

      const principal = parseFloat(loanamount || loanamount || 0);
      const rate = parseFloat(iir || 0);

      const creditInterest =
        (principal * rate * days) / (100 * yearBase);

      const newPrincipal = principal + creditInterest;

      setIsInterestOnly(true);
      setInterestOnlyType("CAPITALIZE");
      setInterestOnlyPayments(days);
      setCapitalizeDays(days);
      // setInterestOnlyInDays(true);

      setCapitalizedInterest(creditInterest.toFixed(2));
      setCapitalizedInterestRate(rate)
      setTotalLoanAmount(newPrincipal.toFixed(2));
      // console.log("Principal:", principal);
      // console.log("Rate:", rate);
      // console.log("Credit Interest:", creditInterest);
      // console.log("New Principal after Capitalization:", newPrincipal);
      const emi = calculatePMT(
        newPrincipal,
        rate,
        parseInt(contract_term || 0),
        paymentfrequency
      );

      setPaymentAmount(emi);

      // const days = Math.ceil(
      //     (actualPaymentDate - basePaymentDate) / (1000 * 60 * 60 * 24)
      // );

      // setInterestOnlyPayments(Math.max(0, days));
      // setInterestOnlyType("CAPITALIZE");
      // setIsInterestOnly(days > 0);

      // setCapitalizeDays(days);

      // const interest =
      //     (loanamount * (iir / 100) * days) / 360;

      // setCapitalizedInterest(interest.toFixed(2));
      // setTotalLoanAmount(
      //     (parseFloat(loanamount) + interest).toFixed(2)
      // );
    }
  }, [
    start_date,
    paymentstartdate,
    paymentfrequency,
    paymentrule,
    // iir,
    loanamount,
    // capitalizedInterestRate,
  ]);

  useEffect(() => {
    if (!isInterestOnly || interestOnlyType !== "CAPITALIZE") return;

    const principal = parseFloat(totalLoanAmount || 0);
    const rate = parseFloat(capitalizedInterestRate || iir || 0);
    const term = parseInt(contract_term || 0);

    // if (!principal || !rate || !term) {
    //   setPaymentAmount("0.00");
    //   return;
    // }

    const emi = calculatePMT(
      principal,
      rate,
      term,
      paymentfrequency
    );

    setPaymentAmount(emi.toFixed(2));

  }, [
    totalLoanAmount,
    capitalizedInterestRate,
    contract_term,
    paymentfrequency,
    isInterestOnly,
    interestOnlyType
  ]);

  const getPeriodStartAndEnd = (baseDate, periodIndex) => {
    const start = new Date(baseDate);

    // move to correct period start
    start.setMonth(start.getMonth() + periodIndex);
    start.setHours(0, 0, 0, 0);

    const end = new Date(start);
    end.setMonth(end.getMonth() + 1);
    end.setDate(end.getDate() - 1); // last day of period

    return { start, end };
  };

  useEffect(() => {
    // if (!paymentstartdate || !contractID) return;
    if (isLoading == true) {

      fetchInterestOnlyData(state, start_date);
    }
    // fetchInterestOnlyData(contractID);
  }, [isLoading]);



  const calculateBilledInterest = (principal, rate, dayConvention) => {
    if (!principal || !rate) return 0;

    let days = 30;
    let yearBase = 360;

    if (dayConvention === "Actual/365") {
      yearBase = 365;
    } else if (dayConvention === "Actual/360") {
      yearBase = 360;
    }

    const interest =
      (principal * (rate / 100) * days) / yearBase;

    return interest.toFixed(2);
  };
  const [actualInterestDays, setActualInterestDays] = useState(0);

  const addMonthsSafe = (date, months) => {
    const d = new Date(date);
    const day = d.getDate();

    d.setDate(1);
    d.setMonth(d.getMonth() + months);

    const lastDay = new Date(
      d.getFullYear(),
      d.getMonth() + 1,
      0
    ).getDate();

    d.setDate(Math.min(day, lastDay));
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const calculateBasePaymentStartDate = () => {
    if (!start_date) return null;

    const contractDate = new Date(start_date);
    if (isNaN(contractDate)) return null;

    contractDate.setHours(0, 0, 0, 0);
    return contractDate;
  };
  useEffect(() => {
    if (!start_date || !paymentstartdate) {
      setActualInterestDays(0);
      return;
    }

    const baseDate = calculateBasePaymentStartDate();
    if (!baseDate) {
      setActualInterestDays(0);
      return;
    }

    const actualDate =
      paymentstartdate instanceof Date
        ? new Date(paymentstartdate)
        : new Date(paymentstartdate);

    if (isNaN(actualDate)) {
      setActualInterestDays(0);
      return;
    }

    // 🔑 Frequency month mapping
    const frequencyMonthsMap = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const freqMonths = frequencyMonthsMap[paymentfrequency] || 0;

    // 🧠 Subtract one full frequency cycle
    const adjustedActualDate = new Date(actualDate);
    adjustedActualDate.setDate(1); // prevent overflow
    adjustedActualDate.setMonth(adjustedActualDate.getMonth() - freqMonths);

    // Clamp day to valid last day
    const lastDay = new Date(
      adjustedActualDate.getFullYear(),
      adjustedActualDate.getMonth() + 1,
      0
    ).getDate();

    adjustedActualDate.setDate(
      Math.min(actualDate.getDate(), lastDay)
    );
    adjustedActualDate.setHours(0, 0, 0, 0);

    // If no delay beyond first cycle → no interest-only days
    if (adjustedActualDate <= baseDate) {
      setActualInterestDays(0);
      return;
    }

    const days = Math.round(
      (adjustedActualDate - baseDate) / (1000 * 60 * 60 * 24)
    );

    setActualInterestDays(days);
  }, [start_date, paymentstartdate, paymentfrequency, paymentrule]);

  // useEffect(() => {
  //     if (!start_date || !paymentstartdate) {
  //         setActualInterestDays(0);
  //         return;
  //     }

  //     const baseDate = getBasePaymentStartDate();
  //     if (!baseDate) return;

  //     const paymentDate = new Date(paymentstartdate);
  //     if (isNaN(paymentDate)) return;

  //     const diffDays = Math.ceil(
  //         (paymentDate - baseDate) / (1000 * 60 * 60 * 24)
  //     );

  //     setActualInterestDays(Math.max(0, diffDays));
  // }, [start_date, paymentstartdate, paymentrule]);

  // console.log("Actual Interest Days:", actualInterestDays);
  // console.log("Actual Interest Days:", billedRows);

  useEffect(() => {
    if (interestOnlyType !== "BILL") return;
    if (!billedRows.length) return;

    const frequencyMonthsMap = {
      Monthly: 1,
      Quarterly: 3,
      "Semi-annual": 6,
      Annual: 12,
    };

    const cycleMonths = frequencyMonthsMap[paymentfrequency] || 1;

    const baseDate = calculateBasePaymentStartDate();
    if (!baseDate) return;

    let periodStart = new Date(baseDate);

    const updated = billedRows.map((row, index) => {
      const periodEnd = addMonthsSafe(periodStart, cycleMonths);
      const periodDays = daysBetween(periodStart, periodEnd);

      const billAmount = calculateInterestAmount(
        loanamount,
        row.interestRate || iir,
        periodDays,          // ✅ CORRECT DAYS
        dayConvention
      );

      periodStart = periodEnd; // move to next cycle

      return {
        ...row,
        interestRate: row.interestRate || iir,
        billAmount: billAmount,
        periodDays: periodDays,           // optional (debug/UI)
      };
    });

    setBilledRows(updated);

  }, [
    iir,
    loanamount,
    dayConvention,
    interestOnlyType,
    paymentfrequency,
    start_date
  ]);
  // useEffect(() => {
  //     if (interestOnlyType !== "BILL") return;
  //     if (!billedRows.length) return;

  //     const updated = billedRows.map(row => ({
  //         ...row,
  //         interestRate: row.interestRate || iir,
  //         billAmount: calculateInterestAmount(
  //             loanamount,
  //             row.interestRate || iir,
  //             actualInterestDays,
  //             row.dayConvention
  //         )
  //     }));

  //     setBilledRows(updated);

  // }, [iir, loanamount, dayConvention, actualInterestDays,interestOnlyType]);

  // useEffect(() => {
  //     if (!billedRows.length) return;

  //     const updated = billedRows.map(row => ({
  //         ...row,
  //         interestRate: row.interestRate,
  //         billAmount: calculateInterestAmount(
  //             loanamount,
  //             row.interestRate,
  //             actualInterestDays,
  //             row.dayConvention
  //         )
  //     }));

  //     setBilledRows(updated);
  // }, [loanamount,dayConvention]);


  const saveInterestOnly = async (contractId) => {
    if (!isInterestOnly) return;

    let rowsPayload = [];

    if (interestOnlyType === "BILL") {
      rowsPayload = billedRows.map(r => ({
        period_no: r.period,
        interest_rate: r.interestRate,
        day_convention: r.dayConvention,
        bill_amount: r.billAmount
      }));
    }

    if (interestOnlyType === "CAPITALIZE") {
      rowsPayload = [{
        period_no: 1,
        interest_rate: capitalizedInterestRate,
        day_convention: dayConvention,
        capitalize_interest_days: capitalizeDays,
        loan_principal: loanamount,
        capitalized_interest: capitalizedInterest,
        total_loan_amount: totalLoanAmount,
        payment_amount: paymentAmount
      }];
    }

    await axios.post(
      `${API}contracts/interest-only/bulk-create/`,
      {
        contract_id: contractId,
        interest_only_type: interestOnlyType,
        rows: rowsPayload
      },
      { headers: authHeader() }
    )
    if (interestOnlyType === "CAPITALIZE") {

      handlepayment();
    }
  };

useEffect(() => {
  if (interestRateType === "Floating") {
    const total = parseFloat(baseRate || 0) + parseFloat(margin || 0);
    setIir(total);
  }
}, [baseRate, margin, interestRateType]);

useEffect(() => {
  if (interestRateType === "Fixed") {
    setBaseRate(0);
    setMargin(0);
  }
}, [interestRateType]);

  return (
    <>
      <div className="container-fluid py-4">
        <div className="header mb-3">
          <h5>{t("Contract Details")}</h5>
          <h6>
            <Link to="/contract" className="tc">
              {t("Contracts")}
            </Link>{" "}
            / <span>{t("Contract Edit")}</span>
          </h6>
        </div>
        <Tabs
          selectedIndex={tabcontractIndex}
          onSelect={(index) => handleTabClick(index)}
        >
          <TabList>
            <Tab onClick={handlecl}>
              <p>{t("Contract Details")}</p>
            </Tab>
            <Tab>
              <p>{t("Party Role")}</p>
            </Tab>
            <Tab>
              <p>{t("Terms & Conditions")}</p>
            </Tab>
            <Tab>
              {/* <p>{t("Assets Details")}</p> */}
              <p>
                {contract_type === "Loan"
                  ? t("Collateral Details")
                  : t("Assets Details")}
              </p>
            </Tab>
            <Tab>
              <p>{"Payment Schedules"}</p>
            </Tab>
            <Tab onClick={clickontab}>
              <p>{t("Amort Schedule")}</p>
            </Tab>
          </TabList>
          <TabPanel>
            <div className="panel-content" style={{ paddingLeft: "10px" }}>
              <div className="header mb-3">
                <ToastContainer autoClose={2000} />
                <SlidingPane
                  className="some-custom-class sidepanebar"
                  isOpen={state1.isPaneOpen}
                  title="Add Customer"
                  subtitle=""
                  onRequestClose={() => {
                    setState1({ isPaneOpen: false });
                  }}
                >
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit2(handlepartydefault)}
                    ref={form2}
                    key={2}
                    action="."
                    method="POST"
                    id="addReceiptForm"
                  >
                    {
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <label className="col-form-label required">
                              {t("Party Type")}{" "}
                              <Tooltip content={t("PartyType_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="form-group row">
                              <div
                                className="form-check"
                                style={{ width: "25%", paddingLeft: "3.0em" }}
                              >
                                <input
                                  className="form-check-input"
                                  checked={
                                    party_type === "Customer" ? true : false
                                  }
                                  value="Customer"
                                  type="radio"
                                  name="vendor"
                                  id="flexRadioDefault2"
                                  onChange={(e) =>
                                    setParty_type(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault2"
                                >
                                  Customer
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label required">
                            {t("Entity Type")}{" "}
                            <Tooltip content={t("EntityType_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="form-group row">
                            <div
                              className="form-check"
                              style={{ width: "25%", paddingLeft: "2.73em" }}
                            >
                              <input
                                className="form-check-input"
                                checked={
                                  customer_type === "Person" ? true : false
                                }
                                value="Person"
                                type="radio"
                                name="person"
                                id="id_customer_type"
                                {...register2("customer_type", {
                                  onChange: (e) => {
                                    handleshowhide(e);
                                  },
                                  required: true,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Person
                              </label>
                            </div>
                            <div
                              className="form-check"
                              style={{ width: "25%", paddingLeft: "4.73em" }}
                            >
                              <input
                                className="form-check-input"
                                checked={
                                  customer_type === "Organization"
                                    ? true
                                    : false
                                }
                                value="Organization"
                                type="radio"
                                name="organization"
                                id="id_customer_type"
                                {...register2("customer_type", {
                                  onChange: (e) => {
                                    handleshowhide(e);
                                  },
                                  required: true,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Organization
                              </label>
                            </div>
                          </div>

                          <div className="invalid-feedback">
                            {errors2.customer_type?.type === "required" &&
                              "Entity Type  is required"}
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-12">
                            <label className="col-form-label required">
                              {t("Party Name")}{" "}
                              <Tooltip content={t("PartyName_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Party Name")}
                              className="form-control"
                              type="text"
                              value={customer_nameparty}
                              name="customer_name"
                              maxLength="200"
                              id="id_customer_name"
                              {...register2("customer_name", {
                                onChange: (e) => {
                                  setCustomer_nameParty(e.target.value);
                                },
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors2.customer_name?.type === "required" &&
                                "Party Name  is required"}
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("Address Line 1")}{" "}
                                <Tooltip content={t("Address_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Address Line 1")}
                                className="form-control"
                                type="text"
                                name="address_line_1"
                                maxLength="200"
                                id="id_address_line_1"
                                value={address_line_1}
                                {...register2("address_line_1", {
                                  onChange: (e) => {
                                    setAddress_line_1(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors2.address_line_1?.type === "required" &&
                                  "Address is required"}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="col-form-label">
                                {t("Address Line 2")}{" "}
                                <Tooltip content={t("Address2_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Address Line 2")}
                                className="form-control"
                                type="text"
                                onChange={(e) =>
                                  setAddress_line_2(e.target.value)
                                }
                                name="address_line_2"
                                maxLength="200"
                                id="id_address_line_2"
                                value={address_line_2}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("City")}{" "}
                                <Tooltip content={t("City_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("City")}
                                className="form-control"
                                type="text"
                                name="city"
                                maxLength="100"
                                id="id_city"
                                value={city}
                                {...register2("city", {
                                  onChange: (e) => {
                                    setCity(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors2.city?.type === "required" &&
                                  "City is required"}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("State")}{" "}
                                <Tooltip content={t("State_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("State")}
                                className="form-control"
                                type="text"
                                name="state"
                                maxLength="30"
                                id="id_state"
                                value={stateaddress}
                                {...register2("state", {
                                  onChange: (e) => {
                                    setStateAddress(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors2.state?.type === "required" &&
                                  "State is required"}
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("Zip Code")}{" "}
                                <Tooltip content={t("ZipCode_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Zip Code")}
                                className="form-control"
                                type="text"
                                name="zip_code"
                                maxLength="30"
                                id="id_zip_code"
                                value={zip_code}
                                {...register2("zip_code", {
                                  onChange: (e) => {
                                    setZip_code(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors2.zip_code?.type === "required" &&
                                  "Zip Code is required"}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("Country")}{" "}
                                <Tooltip content={t("Country_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Country")}
                                className="form-control"
                                type="text"
                                name="country"
                                maxLength="50"
                                id="id_country"
                                value={country}
                                {...register2("country", {
                                  onChange: (e) => {
                                    setCountry(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors2.country?.type === "required" &&
                                  "Country is required"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          type="submit"
                          disabled={disableparty}
                          className="border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {t("Save")}
                        </button>
                        &nbsp;&nbsp;
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn2} />
                  </Form>
                </SlidingPane>
                <SlidingPane
                  className="some-custom-class sidepanebarcontract"
                  isOpen={state5.isPaneOpen}
                  title="Add Payment Amount"
                  subtitle=""
                  onRequestClose={() => {
                    setState5({ isPaneOpen: false });
                    setTermError("");
                  }}
                >
                  <Form
                    role="form text-left"
                    ref={form6}
                    key={6}
                    onSubmit={handleSubmit6(handlePayment)}
                    method="POST"
                    id="addPaymentAmount"
                  >
                    <>
                      <div className="table-responsive-sm">
                        <div className="row pt-3">
                          <div className="col-xl-6">
                            <label className="col-form-label">
                              {t("Payment Lines")}
                            </label>
                          </div>
                          <div className="col-xl-6">
                            <div className="text-right ">
                              <button
                                type="button"
                                className="btn btn-outline-success"
                                onClick={addTableRows}
                              >
                                + {t("ADD")}
                              </button>
                            </div>
                          </div>
                        </div>
                        <table id="invoice" className="table table-nowrap mb-0">
                          <thead>
                            <th>
                              {t("Line no.")}{" "}
                              <Tooltip content={t("LineNumber_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Payment Type")}{" "}
                              <Tooltip content={t("PaymentType_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Amount")}{" "}
                              <Tooltip content={t("Amount_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Payment Frequency")}{" "}
                              <Tooltip content={t("PaymentType_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Total Terms")}{" "}
                              <Tooltip content={t("Totalterm_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Date From")}{" "}
                              <Tooltip content={t("Datefrom_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                            <th>
                              {t("Date To")}{" "}
                              <Tooltip content={t("Dateto_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                          </thead>
                          <tbody>
                            {rowsData.map((data, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Line no.")}{" "}
                                    <Tooltip content={t("LineNumber_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>{index + 1}</div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Type")}{" "}
                                    <Tooltip content={t("PaymentType_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <select
                                      typeof="text"
                                      className="form-control"
                                      value={data.payment_type}
                                      onChange={(evnt) =>
                                        handlePaymentTypeChange(
                                          index,
                                          evnt.target.value
                                        )
                                      }
                                      name="payment_type"
                                      disabled={
                                        data.payment_type === "Rent"
                                          ? true
                                          : false
                                      }
                                    >
                                      {data.payment_type === "Rent" && (
                                        <option value="Rent">Rent</option>
                                      )}
                                      {paymentType.map((key, i) => (
                                        <option key={i} value={key.fee_name}>
                                          {key.fee_name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Amount")}{" "}
                                    <Tooltip content={t("Amount_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <input
                                      type="text"
                                      placeholder="amount"
                                      disabled={data.payment_type === "Rent"}
                                      value={data.amount}
                                      onChange={(evnt) =>
                                        handelChangeAmount(
                                          index,
                                          evnt.target.value
                                        )
                                      }
                                      name="termItem"
                                      className="form-control"
                                    />
                                    <div className="invalid-feedback">
                                      {errors.amount && "Amount is required"}
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Type")}{" "}
                                    <Tooltip content={t("PaymentType_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <select
                                      className="form-control"
                                      value={data.payment_frequency}
                                      disabled={
                                        data.payment_type === "Rent" ||
                                        data.payment_type ===
                                        "Origination Fee" ||
                                        data.payment_type ===
                                        "Documentation Fee"||
                                        data.payment_type ===
                                        "Security Deposit"
                                      }
                                      onChange={(evnt) =>
                                        handlePaymentFrequencyChange(
                                          index,
                                          evnt.target.value
                                        )
                                      }
                                      name="payment_frequency"
                                    >
                                      {paymentFrequencystep.map((key, i) => (
                                        <option key={i} value={key.label}>
                                          {key.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Total Terms")}{" "}
                                    <Tooltip content={t("Totalterm_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <input
                                      type="text"
                                      placeholder="Term"
                                      value={
                                        data.payment_type ===
                                          "Origination Fee" ||
                                          data.payment_type ===
                                          "Documentation Fee" ||
                                          data.payment_type ===
                                          "Security Deposit"
                                          ? 1
                                          : data.no_of_payments
                                      }
                                      onChange={(evnt) =>
                                        handleTermChange(
                                          index,
                                          evnt.target.value
                                        )
                                      }
                                      name="termItem"
                                      className="form-control"
                                      disabled={
                                        data.payment_type ===
                                        "Origination Fee" ||
                                        data.payment_type ===
                                        "Documentation Fee" ||
                                        data.payment_type ===
                                        "Security Deposit" ||
                                        data.payment_type === "Rent"
                                      }
                                      style={{
                                        width: "80px",
                                        fontSize: "12px",
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Date From")}{" "}
                                    <Tooltip content={t("Datefrom_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <input
                                      disabled
                                      type="text"
                                      className="form-control"
                                      name="date_from"
                                      id="payment_startdate"
                                      value={Helper.Dateview(data.start_date)}
                                      style={{
                                        width: "80px",
                                        fontSize: "12px",
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Date To")}{" "}
                                    <Tooltip content={t("Dateto_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <input
                                      disabled
                                      type="text"
                                      className="form-control"
                                      name="date_to"
                                      id="payment_enddate"
                                      value={Helper.Dateview(data.end_date)}
                                      style={{
                                        width: "80px",
                                        fontSize: "12px",
                                      }}
                                    />
                                  </div>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-outline-danger "
                                    onClick={() => deleteTableRows(index)}
                                  >
                                    x
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {termError && (
                          <div className="invalid-feedback">{termError}</div>
                        )}
                      </div>
                    </>
                    <CheckButton style={{ display: "none" }} ref={checkBtn6} />
                    <button
                      type="submit"
                      className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                      // disabled={disablebutton}
                      style={{ marginTop: "5%" }}
                    // onClick={handlePayment}
                    >
                      {t("Save")}
                    </button>
                  </Form>
                </SlidingPane>
                <div className="header  mb-3 pb-0">
                  <h5>{t("Contract Edit")}</h5>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        {isLoading !== true ? (
                          <Form
                            role="form text-left"
                            onSubmit={handleSubmit(handleRegister)}
                            ref={form}
                            action="."
                            method="POST"
                            id="addPartyForm"
                          >
                            {
                              <>
                                <div className="row">
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("Sub Company")}{" "}
                                        <Tooltip
                                          content={t("Subcompany_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          className="form-control"
                                          value={parseInt(subcompany)}
                                          name="subcompany"
                                          id="subcompany"
                                          {...register("subcompany", {
                                            onChange: (e) => {
                                              setSubcompany(e.target.value);
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">
                                            {t("Select Subcompany")}
                                          </option>
                                          {subcompanyOptions.map((option) => (
                                            <option
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.sub_company_name}
                                            </option>
                                          ))}
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.subcompany &&
                                            errors.subcompany.message}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("Line of Business")}{" "}
                                        <Tooltip
                                          content={t("Lineofbusiness_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          className="form-control"
                                          name="lineOfBusiness"
                                          id="lineOfBusiness"
                                          value={lineOfBusiness}
                                          {...register("lineOfBusiness", {
                                            onChange: (e) => {
                                              setLineOfBusiness(e.target.value);
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">
                                            {t("Select Line of Business")}
                                          </option>
                                          {lineOfBusinessOptions.map(
                                            (option) => (
                                              <option
                                                key={option.id}
                                                value={option.id}
                                              >
                                                {option.lob_name}
                                              </option>
                                            )
                                          )}
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.lineOfBusiness &&
                                            errors.lineOfBusiness.message}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Contract Number")}{" "}
                                        <Tooltip
                                          content={t("Contract_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          required
                                          disabled
                                          type="text"
                                          value={contract_number}
                                          onChange={(e) =>
                                            setContract_number(e.target.value)
                                          }
                                          className="form-control"
                                          name="contract_number"
                                          id="contract_number"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Contract Type")}{" "}
                                      <Tooltip
                                        content={t("ContractType_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-12">
                                      <input
                                        required
                                        disabled
                                        type="text"
                                        value={contract_type}
                                        // onChange={(e) => setContract_type(e.target.value)}
                                        className="form-control"
                                        name="contract_type"
                                        id="contract_type"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Customer")}{" "}
                                        <Tooltip
                                          content={t("Customer_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-11">
                                        <AsyncSelect
                                          {...register("selectedValue", {
                                            required: true,
                                          })}
                                          defaultOptions={options}
                                          isClearable
                                          options={options}
                                          value={options.find(
                                            (option) =>
                                              option.id === selectedValue
                                          )}
                                          getOptionLabel={(e) =>
                                            e.customer_name
                                          }
                                          getOptionValue={(e) =>
                                            e.customer_name
                                          }
                                          loadOptions={loadOptions}
                                          onInputChange={handelInputChange}
                                          onChange={handelChange}
                                          placeholder="Select a customer"
                                          name="selectedValue"
                                        ></AsyncSelect>
                                        <div className="invalid-feedback">
                                          {errors.selectedValue &&
                                            "Customer is required"}
                                        </div>
                                      </div>
                                      <div className="col-lg-1">
                                        <img
                                          onClick={() =>
                                            setState1({ isPaneOpen: true })
                                          }
                                          className=""
                                          style={{
                                            height: "20px",
                                            cursor: "pointer",
                                            marginLeft: "-5px",
                                          }}
                                          src={
                                            process.env.PUBLIC_URL +
                                            "/static/images/iconplus.png"
                                          }
                                          alt="ADD"
                                        ></img>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <label className="col-lg-12 col-form-label required">
                                      {t("Bill to Address")}{" "}
                                      <Tooltip
                                        content={t("BilltoAddress_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-12">
                                      {/* <select
                                        value={address_id}
                                        name="address"
                                        id="bill_address"
                                        className="form-control input-lg form-select"
                                        data-live-search="true"
                                        title="Select Address"
                                        placeholder={address_id}
                                        {...register("address", {
                                          onChange: (e) => {
                                            setAdddressId(e.target.value);
                                          },
                                          required: true,
                                        })}
                                      >
                                        <option value="">
                                          ---{t("Select Address")}---
                                        </option>
                                        {address.map((key) => (
                                          <option key={key.id} value={key.id}>
                                            {key.address_line_1},{" "}
                                            {key.address_line_2 !== ""
                                              ? `${key.address_line_2},`
                                              : ""}{" "}
                                            {key.city}, {key.state}, {key.country}{" "}
                                          </option>
                                        ))}
                                      </select> */}
                                      <AsyncSelect
                                        {...register("address", {
                                          required: "Address  is required",
                                        })}
                                        name="address"
                                        cacheOptions
                                        defaultOptions={filterBill}
                                        isClearable
                                        isSearchable
                                        options={filterBill}
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        getOptionValue={(option) =>
                                          option.value
                                        }
                                        onChange={handleBillAddressChange}
                                        loadOptions={loadOptionBillAdd}
                                        value={filterBill.find(
                                          (val) => val.value === address_id
                                        )}
                                        placeholder={`${t("Search Address")}`}
                                      />
                                      <div className="invalid-feedback">
                                        {errors.address &&
                                          errors.address.message}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row"></div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row"></div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Contract Start Date")}{" "}
                                        <Tooltip
                                          content={t(
                                            "ContractStartDate_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <DatePicker
                                          {...register("startdate", {
                                            required: true,
                                          })}
                                          className="form-control"
                                          selected={
                                            start_date
                                              ? new Date(start_date)
                                              : ""
                                          }
                                          onChange={(e) => handelStart_Date(e)}
                                          name="startdate"
                                          placeholderText={"mm/dd/yyyy"}
                                          showYearDropdown // year show and scrolldown alos
                                          scrollableYearDropdown
                                          showMonthDropdown
                                          dropdownMode="select"
                                        />
                                        <div className="invalid-feedback">
                                          {errors.startdate &&
                                            "Start Date  is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("End Date")}{" "}
                                        <Tooltip content={t("EndDate_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          disabled
                                          type="text"
                                          value={Helper.Dateview(end_date)}
                                          className="form-control"
                                          id="enddate"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label  required">
                                        {t("Payment Start Date")}{" "}
                                        <Tooltip
                                          content={t(
                                            "PaymentStartDate_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <DatePicker
                                          {...register("paymentstartdate", {
                                            required: true,
                                          })}
                                          className="form-control"
                                          selected={
                                            paymentstartdate
                                              ? new Date(paymentstartdate)
                                              : ""
                                          }
                                          onChange={(value) =>
                                            Paymentstartdate(value)
                                          }
                                          name="paymentstartdate"
                                          placeholderText={"mm/dd/yyyy"}
                                          // disabled
                                          showYearDropdown // year show and scrolldown alos
                                          scrollableYearDropdown
                                          showMonthDropdown
                                          dropdownMode="select"
                                        />
                                        <div className="invalid-feedback">
                                          {errors.paymentstartdate &&
                                            "Payment Start Date  is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Term")}{" "}
                                        <Tooltip content={t("Term_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={contract_term}
                                          name="contract_term"
                                          id="contract_term"
                                          {...register("contract_term", {
                                            required: "Term is required",
                                            max: {
                                              value:
                                                free.length !== 0
                                                  ? free[0].contract_term
                                                  : 60,
                                              // message: `Term should not be more than ${free.length !== 0 ? free[0].contract_term : 60} for this user plan`,
                                              message: `Maximum term is 60 months. Please enter a term between 1 and 60.`,
                                            },
                                            validate: {
                                              positiveWholeNumber: (value) => {
                                                const numberValue =
                                                  Number(value);
                                                if (isNaN(numberValue)) {
                                                  return "Only numbers are allowed";
                                                } else if (
                                                  numberValue % 1 !==
                                                  0
                                                ) {
                                                  return "Decimal numbers are not allowed";
                                                } else if (
                                                  !Number.isInteger(
                                                    numberValue
                                                  ) ||
                                                  numberValue <= 0
                                                ) {
                                                  return "Only positive numbers are allowed";
                                                }
                                                return true;
                                              },
                                            },
                                            onChange: (e) => {
                                              handelContract_term(
                                                e.target.value
                                              );
                                            },
                                          })}
                                        />
                                        <div className="invalid-feedback">
                                          {errors.contract_term &&
                                            errors.contract_term.message}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {/* {t("Financed Amount")}{" "} */}
                                        {t("Loan Amount")}{" "}
                                        <Tooltip
                                          content={t("LoanAmount_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          value={
                                            loanamount !== 0
                                              ? Helper.Amount(
                                                loanamount - deposit_amount
                                              )
                                              : Helper.Amount(loanamount)
                                          }
                                          onChange={(e) =>
                                            setLoanAmount(e.target.value)
                                          }
                                          type="text"
                                          className="form-control"
                                          name="Loan Amount"
                                          id="contract_number"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <label className="col-form-label">{t("Interest Rate Type")}{(" ")}
                                      <Tooltip content={t("InterestRateType_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="form-group row">

                                                <div className="col-12 col-md-6">
                                                    <div className=" form-check">
                                                     <input
                                                            className="form-check-input"
                                                            
                                                            type="radio"
                                                            name="interestRateType"
                                                            value="Fixed"
                                                            checked={interestRateType === "Fixed"}
                                                            onChange={(e) => setInterestRateType(e.target.value)}
                                                        />
                                                        <label className="form-check-label">
                                                            Fixed
                                                        </label>
                                                    </div>
                                                     </div>
                                                          
                                                           
                                            <div className="col-12 col-md-6">

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="interestRateType"
                                                            value="Floating"
                                                            checked={interestRateType === "Floating"}
                                                            onChange={(e) => setInterestRateType(e.target.value)}
                                                        />
                                                        <label className="form-check-label">
                                                            Floating
                                                        </label>
                                            </div>
                                             </div>
                                               </div>
                                    {/* <select
                                      className="form-control"
                                      value={interestRateType}
                                      onChange={(e) => setInterestRateType(e.target.value)}
                                    >
                                      <option value="Fixed">Fixed</option>
                                      <option value="Floating">Floating</option>
                                    </select> */}
                                  </div>

                                  {interestRateType === "Floating" && (
                                      <>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                          <label className="col-lg-12 col-form-label">{t("Base Rate")}{" "}
                                            <Tooltip content={t("BaseRate_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip></label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={baseRate}
                                            onChange={(e) => setBaseRate(e.target.value)}
                                            onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                            onKeyDown={(e) => {
                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                    e.preventDefault();              // ✅ disables up/down arrow change
                                                }
                                            }}
                                          />
                                        </div>

                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                          <label className="col-lg-12 col-form-label">{t("Margin")}{" "}
                                              <Tooltip content={t("Margin_Tooltip")}>
                                                  <i className="fa fa-light fa-circle-info"></i>
                                              </Tooltip>
                                              </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={margin}
                                            onChange={(e) => setMargin(e.target.value)}
                                            onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                            onKeyDown={(e) => {
                                              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                  e.preventDefault();              // ✅ disables up/down arrow change
                                              }
                                          }}
                                          />
                                        </div>
                                      </>
                                    )}
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Interest Rate")}{" "}
                                        <Tooltip
                                          content={t(
                                            "InterestRate_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          value={iir}
                                          type="number"
                                          step="0.0001"
                                          id="interest"
                                          name="interest"
                                          className="form-control no-spinner"
                                          disabled={interestRateType === "Floating"} 
                                          {...register("interest", {
                                            validate: {
                                              positive: (v) =>
                                                parseFloat(v) >= 0 ||
                                                "Enter Interest Rate Positive Value",
                                            },
                                            onChange: (e) => {
                                              setIir(e.target.value);
                                            },
                                            required:
                                              "Interest Rate is required",
                                          })}
                                          onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
                                          onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                              e.preventDefault();              // ✅ disables up/down arrow change
                                            }
                                          }}
                                        />
                                        <div className="invalid-feedback">
                                          {errors.interest?.message}
                                        </div>
                                      </div>
                                    </div>
                                    </div>
                                    
                                  {/* </div> */}
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      {/* <label className="col-lg-12 col-form-label ">
                                        {t("Interest Only Payments")}{" "}
                                        <Tooltip
                                          content={t(
                                            "InterestOnlyPayments_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          value={interest_only_payments}
                                          type="number"
                                          step="0.0001"
                                          id="interestonlypayments"
                                          name="interestonlypayments"
                                          className="form-control no-spinner"
                                          {...register("interestonlypayments", {
                                            validate: {
                                              positive: (v) =>
                                                parseInt(v) >= 0 ||
                                                "Enter Interest Only Payments Positive Value",
                                            },
                                            onChange: (e) => {
                                              setInterestOnlyPayments(e.target.value);
                                            },
                                            
                                            // required:
                                              // "Interest Rate is required",
                                            required:
                                              false,
                                          })}
                                          onWheel={(e) => e.target.blur()}     // ✅ disables scroll change

                                          onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                              e.preventDefault();              // ✅ disables up/down arrow change
                                            }
                                          }}
                                        />
                                        <div className="invalid-feedback">
                                          {errors.interestonlypayments?.message}
                                        </div>
                                      </div> */}
                                    </div>
                                    {/* ============================= */}
                                    {/* INTEREST ONLY PERIOD (EDIT) */}
                                    {/* ============================= */}

                                    {isInterestOnly && (
                                      <div className="card mt-3 p-3">
                                        <label className="col-form-label">Interest Only Period</label>

                                        <div className="row">
                                          <div className="col-md-6">
                                            <input
                                              type="radio"
                                              checked={interestOnlyType === "BILL"}
                                              onChange={() => setInterestOnlyType("BILL")}
                                            />{" "}
                                            Bill
                                          </div>

                                          <div className="col-md-6">
                                            <input
                                              type="radio"
                                              checked={interestOnlyType === "CAPITALIZE"}
                                              onChange={() => setInterestOnlyType("CAPITALIZE")}
                                            />{" "}
                                            Capitalize
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {isInterestOnly && interestOnlyType === "BILL" && (
                                      <div className="card mt-3 p-3">
                                        <h6>Interest Only – Bill</h6>

                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Period</th>
                                              <th>Interest Rate</th>
                                              <th>Day Convention</th>
                                              <th>Bill Amount</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {billedRows.map((row, index) => (
                                              <tr key={index}>
                                                <td>{row.period}</td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    step="0.0001"
                                                    value={row.interestRate}
                                                    onChange={(e) => {
                                                      const updated = [...billedRows];
                                                      updated[index].interestRate = e.target.value;
                                                      updated[index].billAmount =
                                                        calculateInterestAmount(loanamount, e.target.value, row.periodDays, updated[index].dayConvention);
                                                      setBilledRows(updated);
                                                    }}
                                                  />
                                                </td>
                                                <td>
                                                  <select
                                                    className="form-control"
                                                    value={row.dayConvention}
                                                    //  onChange={(e) =>
                                                    //                     setDayConvention(e.target.value)
                                                    //                 }
                                                    onChange={(e) => {
                                                      const updated = [...billedRows];
                                                      updated[index].dayConvention = e.target.value;

                                                      updated[index].billAmount = calculateInterestAmount(
                                                        loanamount,
                                                        updated[index].interestRate,
                                                        row.periodDays,
                                                        e.target.value
                                                      );

                                                      setBilledRows(updated);
                                                    }}
                                                  >
                                                    <option value="30/360">30/360</option>
                                                    <option value="Actual/365">Actual / 365</option>
                                                    <option value="Actual/360">Actual / 360</option>
                                                  </select>
                                                </td>

                                                <td className="text-end">{Helper.Amount(row.billAmount)}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                    {isInterestOnly && interestOnlyType === "CAPITALIZE" && (
                                      <div className="card mt-3 p-3">
                                        <h6>Interest Only – Capitalize</h6>
                                        <div className="row mb-3">
                                          <div className="col-md-4">
                                            <label>Capitalize Interest Days</label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={capitalizeDays}
                                              readOnly
                                            />
                                          </div>

                                          <div className="col-md-4">
                                            <label>Interest Rate</label>
                                            <input
                                              type="number"
                                              step="0.0001"
                                              className="form-control"
                                              value={capitalizedInterestRate}
                                              onChange={(e) =>
                                                setCapitalizedInterestRate(e.target.value)
                                              }
                                            />
                                          </div>

                                          <div className="col-md-4">
                                            <label>Day Convention</label>
                                            <select
                                              className="form-control"
                                              value={dayConvention}
                                              onChange={(e) =>
                                                setDayConvention(e.target.value)
                                              }
                                            >
                                              <option value="30/360">30/360</option>
                                              <option value="Actual/365">Actual / 365</option>
                                              <option value="Actual/360">Actual / 360</option>
                                            </select>
                                          </div>
                                        </div>

                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Loan Principal</th>
                                              <th>Capitalized Interest</th>
                                              <th>Total Loan Amount</th>
                                              <th>Payment Amount</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>{loanamount}</td>
                                              <td>{capitalizedInterest}</td>
                                              <td>{totalLoanAmount}</td>
                                              <td>{paymentAmount}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-none">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required ">
                                        {t("Interest Calculation Method")}{" "}
                                        <Tooltip
                                          content={t(
                                            "InterestCalculationMethod_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          className="form-control"
                                          value={interestcalculationmethod}
                                          name="interestcalculation"
                                          {...register("interestcalculation", {
                                            onChange: (e) => {
                                              setInterestCalculationMethod(
                                                e.target.value
                                              );
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">Select</option>
                                          <option value="Declining Balance">
                                            Declining Balance
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.interestcalculation &&
                                            "Interest Calculation is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-none">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Repayment Procedure")}{" "}
                                        <Tooltip
                                          content={t(
                                            "RepaymentProcedure_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          value={repaymentprocedure}
                                          className="form-control"
                                          name="repayment"
                                          {...register("repayment", {
                                            onChange: (e) => {
                                              setRepaymentProcedure(
                                                e.target.value
                                              );
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">Select</option>
                                          <option value="Equal Monthly Installment">
                                            Equal Monthly Installment
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.repayment &&
                                            "Repayment is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-none">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Time Counting Method")}{" "}
                                        <Tooltip
                                          content={t(
                                            "TimeCountingMethod_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          value={timecountingmethod}
                                          className="form-control"
                                          name="timecounting"
                                          {...register("timecounting", {
                                            onChange: (e) => {
                                              setTimeCountingMethod(
                                                e.target.value
                                              );
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">Select</option>
                                          <option value="30/360">30/360</option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.timecounting &&
                                            "Time Counting is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-none">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label required">
                                        {t("Payment Method")}{" "}
                                        <Tooltip
                                          content={t("PaymentMethod_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <select
                                          value={paymentmethod}
                                          className="form-control"
                                          name="paymentmethod"
                                          {...register("paymentmethod", {
                                            onChange: (e) => {
                                              setPaymentMethod(e.target.value);
                                            },
                                            required: false,
                                          })}
                                        >
                                          <option value="">Select</option>
                                          <option value="Arrears">
                                            Arrears
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.paymentmethod &&
                                            "Payment Method is required"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-4">
                                  <div className="col-md-6 mb-3 mb-md-0">
                                    <label className="col-form-label">
                                      {t("ACH Payments")}{" "}
                                      <Tooltip
                                        content={t("ACH_Payments_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="achPayments"
                                        checked={achPayments}
                                        {...register("achPayments", {
                                          onChange: (e) =>
                                            setAchPayments(e.target.checked),
                                        })}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="achPayments"
                                      >
                                        Enable ACH Payments
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <label className="col-form-label ">
                                      {t("Bank Account")}{" "}
                                      <Tooltip
                                        content={t("Bank_Account_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="achAccount"
                                      {...register("achAccount", {
                                        required: false,
                                        // required: achPayments
                                        //   ? "Bank Account is required when ACH Payments is enabled"
                                        //   : false,
                                        onChange: (e) =>
                                          setAchAccount(e.target.value),
                                      })}
                                      value={achAccount}
                                      disabled={
                                        !achPayments || achAccounts.length === 0
                                      }
                                    >
                                      <option value="">
                                        Select Bank Account
                                      </option>
                                      {achAccounts.map((account) => (
                                        <option
                                          key={account.id}
                                          value={account.id}
                                        >
                                          {account.account_name ||
                                            `Account ${account.id}`}
                                        </option>
                                      ))}
                                    </select>
                                    <div className="invalid-feedback">
                                      {errors.achAccount &&
                                        errors.achAccount.message}
                                    </div>
                                  </div>
                                  {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("Application Originator")}{" "}
                                        <Tooltip
                                          content={t("ApplicationOrginator_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          type="text"
                                          placeholder="Enter Application Originator"
                                          className="form-control"
                                          value={appOriginator}
                                          onChange={(e) =>
                                            setAppOriginator(e.target.value)
                                          }
                                          name="appOriginator"
                                          id="appOriginator"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("Source")}{" "}
                                        <Tooltip content={t("Source_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Source"
                                          value={source}
                                          onChange={(e) =>
                                            setSource(e.target.value)
                                          }
                                          name="source"
                                          id="source"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      <label className="col-lg-12 col-form-label">
                                        {t("Sales Rep")}{" "}
                                        <Tooltip
                                          content={t("SalesRep_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-12">
                                        <input
                                          type="text"
                                          placeholder="Enter Sales Rep"
                                          className="form-control"
                                          value={salesRep}
                                          onChange={(e) =>
                                            setSalesRep(e.target.value)
                                          }
                                          name="salesRep"
                                          id="salesRep"
                                        />
                                      </div>
                                    </div>
                                  </div> */}

                                </div>
                                <div className="row">
                                  {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <label className="col-lg-6 col-form-label text-left required">
                                      {t("Payment Rule")}{" "}
                                      <Tooltip content={t("PaymentRule_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <select
                                      id="paymentrule"
                                      className="form-control"
                                      name="paymentrule"
                                      value={paymentrule}
                                      {...register("paymentrule", {
                                        onChange: (e) => {
                                          setPaymentRule(e.target.value);
                                        },
                                        required: true,
                                      })}
                                    >
                                      <option value="">
                                        {t("Select Payment Rule")}
                                      </option>
                                      <option value="Advance">
                                        {t("Advance")}
                                      </option>
                                      <option value="Arrears">
                                        {t("Arrears")}
                                      </option>
                                    </select>
                                    <div className="invalid-feedback">
                                      {errors.paymentrule &&
                                        "Payment Rule is required"}
                                    </div>
                                  </div> */}
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <label className="col-lg-6 col-form-label text-left required">
                                      {t("Frequency")}{" "}
                                      <Tooltip content={t("Frequency_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <select
                                      id="frequency"
                                      className="form-control"
                                      name="frequency"
                                      value={paymentfrequency}
                                      // onChange={(e) => setFrequency(e.target.value)}
                                      {...register("frequency", {
                                        onChange: (e) => {
                                          handleFrequencyChange(e.target.value)
                                          // setPaymentFrequency(e.target.value);
                                        },
                                        required: true,
                                      })}
                                    >
                                      <option value="">
                                        {t("Select Frequency")}
                                      </option>
                                      <option value="Monthly">
                                        {t("Monthly")}
                                      </option>
                                      <option value="Quarterly">
                                        {t("Quarterly")}
                                      </option>
                                      <option value="Semi-annual">
                                        {t("Semi-annual")}
                                      </option>
                                      <option value="Annual">
                                        {t("Annual")}
                                      </option>
                                    </select>
                                    <div className="invalid-feedback">
                                      {errors.frequency &&
                                        "Frequency is required"}
                                    </div>
                                  </div>
                                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group row">
                                      {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12"> */}
                                      {/* <div className="form-group row"> */}
                                      <label className="col-lg-12 col-form-label text-left">
                                        {t("Payment Amount")}{" "}
                                        <Tooltip
                                          content={t("PaymentAmount_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-lg-11">
                                        <input
                                          className="form-control"
                                          value="Multiple"
                                          disabled={true}
                                        />
                                        <div className="invalid-feedback">
                                          {errors.paymentamount &&
                                            errors.paymentamount.message}
                                        </div>
                                      </div>
                                      <div className="col-lg-1">
                                        <img
                                          onClick={() =>
                                            setState5({ isPaneOpen: true })
                                          }
                                          className=""
                                          style={{
                                            height: "20px",
                                            cursor: "pointer",
                                            marginLeft: "15px",
                                          }}
                                          src={
                                            process.env.PUBLIC_URL +
                                            "/static/images/iconplus.png"
                                          }
                                          alt="ADD"
                                        ></img>
                                      </div>
                                      {/* <div className="col-lg-11">
                                              {rowsData.length > 1 ? (
                                                <input
                                                  className="form-control"
                                                  value="Multiple"
                                                  disabled={true}
                                                />
                                              ) : (
                                                <CurrencyInput
                                                  className="form-control"
                                                  {...register("paymentamount", {
                                                    required: isDisabled === true ? false : "Payment amount is required",
                                                    validate: isDisabled === true ? false : {
                                                      positive: (v) =>
                                                        parseInt(v) > 0 || "Only positive numbers are allowed",
                                                    },
                                                  })}
                                                  value={amount}
                                                  onValueChange={(value) => { setAmount(value); setDataFetched(true) }}
                                                  name="paymentamount"
                                                  id="input-example"
                                                  disabled={isDisabled}
                                                  allowDecimals="false"
                                                  disableAbbreviations
                                                />
                                              )}
                                              <div className="invalid-feedback">
                                                {errors.paymentamount && errors.paymentamount.message}
                                              </div>
                                            </div> */}
                                      {/* </div> */}
                                      {/* </div> */}

                                      {rowsData && rowsData.length > 0 && (
                                        <div className="col-md-12">
                                          <MaterialTable
                                            // tableRef={tableRef}
                                            style={{
                                              backgroundColor:
                                                "var(--bs-table-bg)",
                                              borderBottomWidth: "1px",
                                              boxShadow:
                                                "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                            }}
                                            title={
                                              <label className="col-lg-6 col-form-label text-left">
                                                {t("Preview Payment Amounts")}{" "}
                                                <Tooltip
                                                  content={t(
                                                    "Preview Payment Amounts"
                                                  )}
                                                >
                                                  <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip>
                                              </label>
                                            }
                                            columns={[
                                              {
                                                title: `${t(
                                                  "No. of Payments"
                                                )}`,
                                                field: "no_of_payments",
                                                headerStyle: {
                                                  verticalAlign: "inherit",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                },
                                                cellStyle: {
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                },
                                                render: (rowData) => (
                                                  <>
                                                    {" "}
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                      {t("No. of Payments")}
                                                    </div>
                                                    <div>
                                                      {rowData.no_of_payments}
                                                    </div>
                                                  </>
                                                ),
                                              },
                                              {
                                                title: `${t("Payment Type")}`,
                                                field: "payment_type",
                                                render: (rowData) => (
                                                  <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                      {t("Payment Type")}
                                                    </div>{" "}
                                                    <div>
                                                      {rowData.payment_type}
                                                    </div>
                                                  </>
                                                ),
                                                headerStyle: {
                                                  verticalAlign: "inherit",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                },
                                                cellStyle: {
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                },
                                              },
                                              {
                                                title: `${t("Amount")}`,
                                                field: "amount",
                                                render: (rowData) => (
                                                  <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                      {t("Amount")}
                                                    </div>
                                                    <div>
                                                      {Helper.Amount(
                                                        rowData.amount
                                                      )}
                                                    </div>
                                                  </>
                                                ),
                                                headerStyle: {
                                                  verticalAlign: "inherit",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                },
                                                cellStyle: {
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                },
                                              },
                                              {
                                                title: `${t("Start Date")}`,
                                                field: "start_date",
                                                render: (rowData) => (
                                                  <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                      {" "}
                                                      {t("Start Date")}
                                                    </div>
                                                    <div>
                                                      {Helper.DateNormal(
                                                        rowData.start_date
                                                      )}
                                                    </div>
                                                  </>
                                                ),
                                                headerStyle: {
                                                  verticalAlign: "inherit",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                },
                                                cellStyle: {
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                },
                                              },
                                              {
                                                title: `${t("End Date")}`,
                                                field: "end_date",
                                                render: (rowData) => (
                                                  <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                      {t("End Date")}
                                                    </div>
                                                    <div>
                                                      {Helper.DateNormal(
                                                        rowData.end_date
                                                      )}
                                                    </div>
                                                  </>
                                                ),
                                                headerStyle: {
                                                  verticalAlign: "inherit",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                },
                                                cellStyle: {
                                                  textAlign: "left",
                                                  fontSize: 12,
                                                },
                                              },
                                            ]}
                                            data={rowsData}
                                            localization={{
                                              toolbar: {
                                                searchPlaceholder:
                                                  "Search Contracts",
                                              },
                                            }}
                                            options={{
                                              headerStyle: {
                                                backgroundColor: "white",
                                                color: "#245C7F",
                                                fontSize: 11,
                                              },
                                              rowStyle: (rowData, index) => {
                                                if (index % 2) {
                                                  return {
                                                    backgroundColor: "#fff",
                                                  };
                                                }
                                              },
                                              sorting: true,
                                              search: false,
                                              toolbar: true,
                                              paging: true,
                                              pageSize: 3, // make initial page size
                                              emptyRowsWhenPaging: false, // To avoid of having empty rows
                                              pageSizeOptions: [
                                                3, 5, 10, 20, 25, 50,
                                              ],
                                              paginationType: "stepped",
                                              showFirstLastPageButtons: false,
                                              exportAllData: false,
                                              exportButton: false,
                                              actionsColumnIndex: -1,
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {extrafiledcontract.length === 0 ? (
                                  ""
                                ) : (
                                  <h4 className="tc mt-4">
                                    {t("Additional Information")} :
                                  </h4>
                                )}
                                <div className="form-group row">
                                  {extrafiledcontract.map((key, index) => (
                                    <div
                                      className={
                                        key.enable === "True"
                                          ? "col-sm-6"
                                          : null
                                      }
                                    >
                                      <>
                                        <label
                                          style={{
                                            display:
                                              key.enable === "True"
                                                ? true
                                                : "none",
                                          }}
                                          className="col-form-label"
                                        >
                                          {" "}
                                          {key.label}{" "}
                                          <Tooltip content={key.label}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <input
                                          style={{
                                            display:
                                              key.enable === "True"
                                                ? true
                                                : "none",
                                          }}
                                          id={"attribute_" + index}
                                          value={
                                            attribute[index]["attribute"]
                                              ? attribute[index]["attribute"]
                                              : ""
                                          }
                                          className="form-control mb-1"
                                          name="attribute"
                                          type={key.datatype}
                                          placeholder={key.label}
                                          onChange={(e) =>
                                            onChangeextrafileds(e, index)
                                          }
                                        />
                                      </>
                                    </div>
                                  ))}
                                </div>
                                <input
                                  type="hidden"
                                  value="Entered"
                                  className="form-control"
                                  name="status"
                                  id="status"
                                  disabled
                                />
                                <input
                                  type="hidden"
                                  className="form-control"
                                  name="sign_date"
                                  id="signdate"
                                />
                                <textarea
                                  style={{ display: "none" }}
                                  className="form-control"
                                  id="description"
                                  name="description"
                                ></textarea>
                                <input
                                  type="hidden"
                                  style={{ display: "none" }}
                                  value="USD"
                                  className="form-control"
                                  name="currency"
                                  id="currency"
                                />
                                <input
                                  type="hidden"
                                  value="{{ contract.address.id }}"
                                  id="contract_aid"
                                />
                                <input
                                  type="hidden"
                                  value="{{ contract.party.id }}"
                                  id="contract_cid"
                                />
                                <input
                                  type="hidden"
                                  value="{{ contract.id }}"
                                  id="contract_id"
                                />
                                <div className="text-left py-3">
                                  <button
                                    type="submit"
                                    disabled={disablecontract}
                                    className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                  >
                                    {loading === false ? (
                                      t("Update")
                                    ) : (
                                      <ButtonLoading />
                                    )}
                                  </button>
                                  &nbsp;&nbsp;
                                  {asset_count && payment_count ? (
                                    <button
                                      type="button"
                                      disabled={disablecontractactive}
                                      className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                      onClick={handleactivation}
                                    >
                                      {activeloading === false ? (
                                        t("Activate Contract")
                                      ) : (
                                        <ButtonLoading />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  <span id="activeContract"></span>
                                </div>
                              </>
                            }
                            <CheckButton
                              style={{ display: "none" }}
                              ref={checkBtn}
                            />
                          </Form>
                        ) : (
                          <ContentLoader
                            viewBox="0 0 1000 550"
                            backgroundColor="rgba(0,0,0,0.06)"
                            foregroundColor="rgba(0,0,0,0.12)"
                          >
                            <rect
                              x="51"
                              y="45"
                              rx="3"
                              ry="3"
                              width="906"
                              height="17"
                            />
                            <circle cx="879" cy="123" r="11" />
                            <circle cx="914" cy="123" r="11" />
                            <rect
                              x="104"
                              y="115"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="305"
                              y="114"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="661"
                              y="114"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="55"
                              y="155"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <circle cx="880" cy="184" r="11" />
                            <circle cx="915" cy="184" r="11" />
                            <rect
                              x="105"
                              y="176"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="306"
                              y="175"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="662"
                              y="175"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="56"
                              y="216"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <circle cx="881" cy="242" r="11" />
                            <circle cx="916" cy="242" r="11" />
                            <rect
                              x="106"
                              y="234"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="307"
                              y="233"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="663"
                              y="233"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="57"
                              y="274"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <circle cx="882" cy="303" r="11" />
                            <circle cx="917" cy="303" r="11" />
                            <rect
                              x="107"
                              y="295"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="308"
                              y="294"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="664"
                              y="294"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="58"
                              y="335"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <circle cx="881" cy="363" r="11" />
                            <circle cx="916" cy="363" r="11" />
                            <rect
                              x="106"
                              y="355"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="307"
                              y="354"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="663"
                              y="354"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="57"
                              y="395"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <circle cx="882" cy="424" r="11" />
                            <circle cx="917" cy="424" r="11" />
                            <rect
                              x="107"
                              y="416"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="308"
                              y="415"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="664"
                              y="415"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="55"
                              y="453"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <rect
                              x="51"
                              y="49"
                              rx="3"
                              ry="3"
                              width="2"
                              height="465"
                            />
                            <rect
                              x="955"
                              y="49"
                              rx="3"
                              ry="3"
                              width="2"
                              height="465"
                            />
                            <circle cx="882" cy="484" r="11" />
                            <circle cx="917" cy="484" r="11" />
                            <rect
                              x="107"
                              y="476"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="308"
                              y="475"
                              rx="3"
                              ry="3"
                              width="299"
                              height="15"
                            />
                            <rect
                              x="664"
                              y="475"
                              rx="3"
                              ry="3"
                              width="141"
                              height="15"
                            />
                            <rect
                              x="55"
                              y="513"
                              rx="3"
                              ry="3"
                              width="897"
                              height="2"
                            />
                            <rect
                              x="52"
                              y="80"
                              rx="3"
                              ry="3"
                              width="906"
                              height="17"
                            />
                            <rect
                              x="53"
                              y="57"
                              rx="3"
                              ry="3"
                              width="68"
                              height="33"
                            />
                            <rect
                              x="222"
                              y="54"
                              rx="3"
                              ry="3"
                              width="149"
                              height="33"
                            />
                            <rect
                              x="544"
                              y="55"
                              rx="3"
                              ry="3"
                              width="137"
                              height="33"
                            />
                            <rect
                              x="782"
                              y="56"
                              rx="3"
                              ry="3"
                              width="72"
                              height="33"
                            />
                            <rect
                              x="933"
                              y="54"
                              rx="3"
                              ry="3"
                              width="24"
                              height="33"
                            />
                          </ContentLoader>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  type="hidden"
                  value=""
                  id="contract_id"
                  name="contract_id"
                />
                <div className="row mt-4" id="payschedule"></div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div
              className="panel-content"
              style={{ paddingLeft: "10px" }}
            >
              <ContractShortview
                contract={contract}
                TotalIncome={TotalIncome}
                iir={iir}
              />

              <PartyRoleList
                id={state}
                contracttype={contract_type}
                setTab={tabcontractIndex}
                party_id={customer_id}
              />


            </div>
          </TabPanel>
          <TabPanel>
            <div
              className="panel-content"
              style={{ paddingLeft: "10px" }}
            >
              <ContractShortview
                contract={contract}
                TotalIncome={TotalIncome}
                iir={iir}
              />

              <TermConditionContractView
                contract_id={state}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="panel-content" style={{ paddingLeft: "10px" }}>
              <ContractShortview
                contract={contract}
                TotalIncome={TotalIncome}
                iir={iir}
              />
              {!assetid ? (
                <AssetList
                  id={state}
                  contracttype={contract_type}
                  party_id={customer_id}
                />
              ) : (
                <div className="mt-3 pt-5">
                  <AssetView
                    asset_id={assetid}
                    id={state}
                    contracttype={contract_type}
                    setassetID={setassetID}
                  ></AssetView>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="panel-content" style={{ paddingLeft: "10px" }}>
              <ContractShortview
                contract={contract}
                TotalIncome={TotalIncome}
                iir={iir}
              />
              <PaymentScheduleview
                id={{ contract_id: state, contract_start_date: start_date }}
                data_count={data_count}
                contracttype={contract_type}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="panel-content" style={{ paddingLeft: "10px" }}>
              <ContractShortview
                contract={contract}
                TotalIncome={TotalIncome}
                iir={iir}
              />
              {paymentrule === "Arrears" ? (
                <AmortizationScheduleArrears
                  startdate={start_date}
                  totalRent={totalRent}
                  totalIncome={totalIncome}
                  paymentfrequency={paymentfrequency}
                  financedamount={loanamount}
                  contractiir={iir}
                  paymentrule={paymentrule}
                  paymentamount={rentamount}
                  numberofpayment={numberofpayment}
                  residual={residual}
                  setarrears={amortcalcu}
                  contracttype={contract_type}
                  contract_term={contract_term}
                  feesontime={totalonetimefee}
                  baseRate={baseRate}
                  margin={margin}
                  InterestRateType={interestRateType}
                />
              ) : (
                <AmortizationSchedule
                  startdate={start_date}
                  totalRent={totalRent}
                  totalIncome={totalIncome}
                  paymentfrequency={paymentfrequency}
                  financedamount={loanamount}
                  contractiir={iir}
                  paymentrule={paymentrule}
                  paymentamount={rentamount}
                  numberofpayment={numberofpayment}
                  residual={residual}
                  setarrears={amortcalcu}
                  contracttype={contract_type}
                  contract_term={contract_term}
                  feesontime={totalonetimefee}
                  baseRate={baseRate}
                  margin={margin}
                />
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
}

export default EditLoanScreen;
